var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { combineEpics } from "redux-observable";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { AsyncRequestStatus, getDefaultAsyncWrapperObj, requestPendingOrCompleted, getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
import VivaceResoures from "./module/views/VivaceResoures.js";
import { createAction } from "typesafe-actions";
import ___default from "lodash";
import { mapIfDefined } from "@ane/core/lib/utils/CollectionUtils";
import { getWorkspaceIdSelector } from "./module/views/Maui.selectors.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { MetricsAuthoringRouteUtils } from "@ane/exp-data/lib/routes/MetricsAuthoringRoute.utils";
import { MAUIConfigurationPaths, MAUIDraftEntityPaths } from "./module/common/models/MAUI.models.js";
import { draftMetricsQueryStringEpics } from "./module/views/VivaceUserContext.epics.js";
import { getDraftWorkspaceDictionaryKey } from "./module/common/components/CheckUserAccess/CheckUserAccess.selectors.js";
import { SetSubscribersEpicReducer, loadSubscribersEpicReducer } from "@ane/exp-ux/lib/components/Subscribers";
import { ENTITY_TYPES } from "@ane/exp-data/lib/models/SubscriberModels";
import { ComputationTypes } from "./module/common/models/MDLComputations.js";
import { RestResult } from "@ane/core/lib/services/RestServiceBase";
import AnalysisResource from "@ane/exp-data/lib/resources/expapiv2/Analysis.resource";
import AnalysisResources from "@ane/summary-app-module/lib/module/views/Analysis/module/AnalysisResources";
import legacyExperimentResource from "@ane/exp-data/lib/resources/ExperimentResources";
import experimentUnifiedResource from "@ane/exp-data/lib/resources/expapiunified/Experiment.resource";
import FeatureResources from "@ane/exp-data/lib/resources/FeatureReadV2Resource";
import featureUnifiedResource from "@ane/exp-data/lib/resources/expapiunified/Feature.resource";
import { addOrUpdateMDLComputationFile } from "./module/common/utils/MDLComputations.utils.js";
import MetricServiceResource from "@ane/exp-data/lib/resources/MetricServiceResource";
import { PRODUCTION_BRANCH_ID } from "./module/constants/maui.constants.js";
import Logger from "@ane/core/lib/services/logging/Logger";
import { NewSegmentUITelemetryEventNames } from "./module/constants/NewSegmentUITelemetryEventNames.js";
import { ROUTES } from "@ane/exp-data/lib/routes/Routes.constants";
import { ExperimentSearchRouteUtils } from "@ane/exp-data/lib/routes/ExperimentSearchRoute.utils";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { LearnMoreLink, StackItem, Label, IconButton, CreateEntityPanel } from "@ane/ui-components";
import { defaultGuid } from "@ane/exp-data/lib/constants/guid.constants";
import { getExperimentUrl } from "@ane/exp-data/lib/utils/ExperimentUrlUtils";
import * as React from "react";
import { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { ScenarioLoggingContext } from "@ane/core/lib/services/logging/ScenarioLoggingProvider";
import { MAUI_METRIC_LOG, previewScorecardLogProperties } from "@ane/exp-data/lib/constants/maui.constants";
import { MetricsAuthoringScenarioLoggingNames } from "@ane/exp-data/lib/telemetry/MetricsAuthoringScenarioLoggingNames";
import { Heading } from "@ane/ui-components/lib/components/Heading";
import { ChoiceGroupField } from "@ane/ui-components/lib/components/FormikFormFields/ChoiceGroupField";
import { Stack, StackItem as StackItem$1 } from "@ane/ui-components/lib/components/Deprecated/Stack";
import { ExternalLink } from "@ane/ui-components/lib/components/ExternalLink";
import { FormSection } from "@ane/ui-components/lib/components/FormSection";
import { SearchDropdownField } from "@ane/ui-components/lib/components/FormikFormFields";
import { ControlTowerLoading } from "@ane/exp-ux/lib/components/ControlTowerLoading";
import { SearchDropdownField as SearchDropdownField$1 } from "@ane/ui-components/lib/components/FormikFormFields/SearchDropdownField";
import { CREATE_METRIC_SET_FIELDS } from "./module/views/CreateMetricSet/CreateMetricSetForm.constants.js";
import { GarRouteUtils } from "@ane/exp-data/lib/routes/GuidedAnalysisResultsRoute.utils";
import { FeatureProgressionRouteUtils } from "@ane/exp-data/lib/routes/FeatureProgressionRoute.utils";
import { WORKSPACE_ID } from "@ane/core/lib/constants/QueryString.constants";
import { ExperimentStates, ExperimentStepType } from "@ane/exp-data/lib/models";
const PreviewScorecardNavPaneAriaLabel = "Preview scorecard navigation";
const PreviewDetailsListId = "published-versions-list";
const PreviewCommandBarId = "published-versions-list-actions";
var PublishedVersionFilterOptions = /* @__PURE__ */ ((PublishedVersionFilterOptions2) => {
  PublishedVersionFilterOptions2["Current_draft"] = "Current_draft";
  PublishedVersionFilterOptions2["Draft"] = "Draft";
  PublishedVersionFilterOptions2["Published_version"] = "Published_version";
  PublishedVersionFilterOptions2["Published_by"] = "Published_by";
  return PublishedVersionFilterOptions2;
})(PublishedVersionFilterOptions || {});
const PublishedVersionsFilterOptions = {
  Current_draft: {
    key: "Current draft",
    name: "Current draft"
  },
  Draft: {
    key: "Draft",
    name: "Draft"
  },
  Published_version: {
    key: "Published version",
    name: "Published version"
  },
  Published_by: {
    key: "Published by",
    name: "Published by"
  },
  key: "published-version-filter-options",
  dropdownProps: {
    ariaLabel: "Select column to filter by"
  }
};
const PublishedVersionListCommandBarLabels = {
  createPreviewScorecard: {
    text: "Create preview scorecard",
    ariaLabel: "Create preview scorecard from published versions page"
  }
};
const PublishedVersionListLabels = {
  commandBar: {
    ariaLabel: "Published versions actions"
  },
  detailsList: {
    ariaLabel: "Published versions",
    ariaLabelForGrid: "Published versions",
    checkButtonAriaLabel: "Select published version"
  }
};
const PublishedVersionListColumnNames = {
  id: { name: "Published version" },
  draft: { name: "Draft" },
  publishedBy: { name: "Published by" },
  publishDate: { name: "Publish date" },
  publishStatus: { name: "Status" }
};
var RecentAnalysisFilterOptions = /* @__PURE__ */ ((RecentAnalysisFilterOptions2) => {
  RecentAnalysisFilterOptions2["Current_draft"] = "Current_draft";
  RecentAnalysisFilterOptions2["Draft"] = "Draft";
  RecentAnalysisFilterOptions2["Analysis_study"] = "Analysis_study";
  RecentAnalysisFilterOptions2["Published_version"] = "Published_version";
  RecentAnalysisFilterOptions2["Created_by"] = "Created_by";
  return RecentAnalysisFilterOptions2;
})(RecentAnalysisFilterOptions || {});
const RecentPreviewAnalysisFilterOptions = {
  Current_draft: {
    key: "Current draft",
    name: "Current draft"
  },
  Draft: {
    key: "Draft",
    name: "Draft"
  },
  Analysis_study: {
    key: "Analysis study",
    name: "Analysis study"
  },
  Published_version: {
    key: "Published version",
    name: "Published version"
  },
  Created_by: {
    key: "Created by",
    name: "Created by"
  },
  key: "recent-preview-analysis-filter-options",
  dropdownProps: {
    ariaLabel: "Select column to filter by"
  }
};
const RecentPreviewAnalysisListLabels = {
  commandBar: {
    ariaLabel: "Recent analysis actions"
  },
  detailsList: {
    ariaLabel: "recent analysis",
    ariaLabelForGrid: "recent analysis"
  }
};
const RecentPreviewAnalysisListColumnNames = {
  id: { name: "Analysis study" },
  version: { name: "Published version" },
  draft: { name: "Draft" },
  createdBy: { name: "Created by" },
  createdDate: { name: "Created date" }
};
const CREATE_PREVIEW_SCORECARD = {
  experimentStepId: {
    validation: {
      required: {
        message: "Experiment step is required"
      },
      empty: {
        message: "No suitable experiment steps found"
      }
    }
  },
  experimentationGroup: {
    validation: {
      required: {
        message: "Experimentation group is required"
      }
    }
  },
  featureId: {
    validation: {
      required: {
        message: "Experiment is required"
      },
      empty: {
        message: "No experiments found"
      }
    }
  }
};
const CreateAnalysisButton = {
  ariaLabel: "Create analysis",
  text: "Create analysis",
  iconProps: { iconName: "OpenInNewTab", ariaLabel: "open experiment in new tab" }
};
const ExperimentStepLabelInfoIcon = {
  ariaLabel: "Experiment step list details",
  iconName: "Info",
  content: "Non-AB steps and steps that are not started are not shown in this list since they cannot be used to create an analysis"
};
const RecentExperimentStepLabelInfoIcon = {
  ariaLabel: "Recent experiment step details",
  iconName: "Info",
  content: "Only experiment steps in which you have generated a preview scorecard analysis using this metric set are shown in this list"
};
const DefaultExperimentStepLabelInfoIcon = {
  ariaLabel: "Default experiment step details",
  iconName: "Info",
  content: "Only experiment steps in this workpsace that are set as default experiment steps for this metric set are shown in this list"
};
const PreviewFromExperimentStepLinkProps = {
  "aria-label": "Learn more about preview scorecard creation from experiment step",
  text: "Learn more",
  href: "https://aka.ms/exp/preview-scorecard-from-experiment-step"
};
const LegacyExperimentSearchInfoIconProps = (workspaceId) => {
  return {
    ariaLabel: "Experiment search details",
    iconName: "Info",
    calloutProps: {
      content: /* @__PURE__ */ jsxs("p", { children: [
        "Search returns only the most recent ",
        EnvironmentService.previewScorecardSearchCountLegacy(),
        " experiments in the selected experimentation group. If you're having trouble finding the right experiment step, you can visit the",
        " ",
        /* @__PURE__ */ jsx("a", { href: getSearchURL(workspaceId), target: "_blank", rel: "noopener noreferrer", children: "experiment list page" }),
        " ",
        "to locate it and create a preview analysis. ",
        /* @__PURE__ */ jsx(LearnMoreLink, __spreadValues({}, PreviewFromExperimentStepLinkProps))
      ] })
    }
  };
};
const UnifiedFeatureSearchInfoIconProps = (workspaceId) => {
  return {
    ariaLabel: "Feature search details",
    iconName: "Info",
    calloutProps: {
      content: /* @__PURE__ */ jsxs("p", { children: [
        "Search returns only the most recent ",
        EnvironmentService.previewScorecardSearchCountUnified(),
        " features in the selected experimentation group. If you're having trouble finding the right experiment step, you can visit the",
        " ",
        /* @__PURE__ */ jsx("a", { href: getSearchURL(workspaceId), target: "_blank", rel: "noopener noreferrer", children: "feature list page" }),
        " ",
        "to locate it and create a preview analysis. ",
        /* @__PURE__ */ jsx(LearnMoreLink, __spreadValues({}, PreviewFromExperimentStepLinkProps))
      ] })
    }
  };
};
const TeachingBubbleProps = {
  closeButtonAriaLabel: "Close",
  headline: "New preview scorecard experience",
  button: {
    text: "Dismiss"
  }
};
const teachingBubbleContent = () => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx("p", { children: "You would need to publish your draft before creating a preview scorecard in the new preview scorecard experience." }),
  /* @__PURE__ */ jsxs("p", { children: [
    "To publish your draft click the dropdown and select ",
    /* @__PURE__ */ jsx("b", { children: "Publish" }),
    " and click the ",
    /* @__PURE__ */ jsx("b", { children: "Publish draft" }),
    " button."
  ] })
] });
const selectStepComboBoxStyle = {
  optionText: [
    {
      overflow: "hidden",
      whiteSpace: "nowrap"
    },
    {
      selectors: {
        ":hover": [
          {
            overflow: "visible",
            whiteSpace: "normal",
            height: "auto"
          }
        ]
      }
    }
  ]
};
const RecentExperimentStepsSelection = () => {
  const dispatch = useDispatch();
  const workspaceId = useSelector(getWorkspaceIdSelector);
  const [selectedExperimentStep, setSelectedExperimentStep] = useState();
  const recentPreviewAnalysis = useSelector((state) => state.maui.draft.recent_preview_analyses);
  const recentExperiments = useSelector((state) => state.maui.draft.recent_experiments);
  const recentFeatures = useSelector((state) => state.maui.draft.recent_features);
  const { values, setFieldValue } = useFormikContext();
  const experimentStepOptions = getRecentExperimentStepsOptions(
    recentPreviewAnalysis,
    recentExperiments,
    recentFeatures,
    workspaceId
  );
  useEffect(() => {
    if (!!(selectedExperimentStep == null ? void 0 : selectedExperimentStep.experimentId)) {
      setFieldValue("experimentIdFromRecentAnalyses", selectedExperimentStep == null ? void 0 : selectedExperimentStep.experimentId);
    }
    if (!!(selectedExperimentStep == null ? void 0 : selectedExperimentStep.featureId)) {
      setFieldValue("featureIdFromRecentAnalyses", selectedExperimentStep == null ? void 0 : selectedExperimentStep.featureId);
    }
  }, [setFieldValue, selectedExperimentStep]);
  return /* @__PURE__ */ jsx(
    ControlTowerLoading,
    {
      useProgressIndicator: false,
      resources: [
        {
          asyncData: recentPreviewAnalysis,
          displayName: "recent preview analysis",
          onRetry: () => dispatch(loadRecentPreviewAnalysisEpicReducer.actionCreators.load({ getExperimentSteps: true }))
        },
        {
          asyncData: recentExperiments,
          displayName: "recent experiment steps"
        },
        {
          asyncData: recentFeatures,
          displayName: "recent features"
        }
      ],
      children: /* @__PURE__ */ jsxs(StackItem, { children: [
        /* @__PURE__ */ jsx(
          Label,
          {
            htmlFor: "recentExperimentStepSelection",
            text: "Experiment step",
            iconProps: {
              ariaLabel: RecentExperimentStepLabelInfoIcon.ariaLabel,
              iconName: RecentExperimentStepLabelInfoIcon.iconName,
              calloutProps: {
                content: /* @__PURE__ */ jsx(Fragment, { children: RecentExperimentStepLabelInfoIcon.content })
              }
            },
            required: true
          }
        ),
        /* @__PURE__ */ jsxs(StackItem, { style: { display: "flex" }, children: [
          /* @__PURE__ */ jsx(StackItem, { style: { flexGrow: 6 }, children: /* @__PURE__ */ jsx(
            SearchDropdownField,
            {
              placeholder: "Select a recent experiment step",
              name: "experimentStepIdFromRecentAnalyses",
              id: "recentExperimentStepSelection",
              ariaLabel: "Please select a recent experiment step",
              options: experimentStepOptions,
              calloutProps: {
                calloutMaxHeight: 300
              },
              onChange: (ev, option) => {
                setSelectedExperimentStep(option == null ? void 0 : option.data);
              },
              comboBoxOptionStyles: selectStepComboBoxStyle
            }
          ) }),
          /* @__PURE__ */ jsx(
            IconButton,
            {
              ariaLabel: "View experiment step",
              text: "View",
              disabled: !values.experimentIdFromRecentAnalyses,
              onClick: () => viewExperiment(values.experimentIdFromRecentAnalyses, values.featureIdFromRecentAnalyses),
              iconProps: { iconName: "OpenInNewTab", ariaLabel: "open experiment in new tab" }
            }
          )
        ] })
      ] })
    }
  );
};
const UnifiedSearchExperiments = () => {
  var _a, _b;
  const dispatch = useDispatch();
  const workspaceId = useSelector(getWorkspaceIdSelector);
  const experimentationGroupsAsync = useSelector((state) => state.maui.global.experimentation_groups);
  const experimentationGroupFeaturesAsync = useSelector((state) => state.maui.draft.experimentation_group_features);
  const featureProgressionsAsync = useSelector((state) => state.maui.draft.feature_progressions);
  const experimentAsync = useSelector((state) => state.maui.draft.experiment);
  const { values, setFieldValue } = useFormikContext();
  const isFeaturesListLoading = () => {
    return (experimentationGroupFeaturesAsync == null ? void 0 : experimentationGroupFeaturesAsync.status) === AsyncRequestStatus.Pending;
  };
  const isFeatureProgressionsLoading = () => {
    return (featureProgressionsAsync == null ? void 0 : featureProgressionsAsync.status) === AsyncRequestStatus.Pending;
  };
  const isExperimentLoading = () => {
    return (experimentAsync == null ? void 0 : experimentAsync.status) === AsyncRequestStatus.Pending;
  };
  const _onSelectedEGChange = (event, option) => {
    var _a2;
    setFieldValue("featureIdFromSearch", "");
    setFieldValue("experimentIdFromSearch", "");
    setFieldValue("experimentStepIdFromSearch", "");
    dispatch(
      loadFeaturesForExperimentationGroupEpicReducer.actionCreators.load({
        workspaceId,
        experimentationGroup: (_a2 = option == null ? void 0 : option.data.path) != null ? _a2 : ""
      })
    );
  };
  const _onSelectedFeatureChange = (event, option) => {
    var _a2;
    setFieldValue("experimentIdFromSearch", "");
    setFieldValue("experimentStepIdFromSearch", "");
    const feature = option == null ? void 0 : option.data;
    if (((_a2 = feature == null ? void 0 : feature.propertyBag) == null ? void 0 : _a2.IsFeatureRollout) === false) {
      setFieldValue("isFeatureRollout", false);
      dispatch(
        loadExperimentEpicReducer.actionCreators.load({
          experimentId: feature.id
        })
      );
    } else {
      setFieldValue("isFeatureRollout", true);
      dispatch(
        loadFeatureProgressionsEpicReducer.actionCreators.load({
          featureId: feature.id
        })
      );
    }
  };
  return /* @__PURE__ */ jsx(
    ControlTowerLoading,
    {
      useProgressIndicator: false,
      resources: [
        {
          asyncData: experimentationGroupsAsync,
          displayName: "Experimentation Groups",
          onRetry: () => dispatch(loadAllExperimentationGroupsEpicReducer.actionCreators.load({}))
        }
      ],
      children: /* @__PURE__ */ jsxs(FormSection, { children: [
        /* @__PURE__ */ jsx(
          SearchDropdownField$1,
          {
            name: "experimentationGroup",
            ariaLabel: "Experimentation group",
            label: "Experimentation group",
            placeholder: "Select experimentation group",
            options: ((_a = experimentationGroupsAsync.data) == null ? void 0 : _a.map((group) => ({
              key: group.id,
              text: group.path,
              data: group
            })).sort()) || [],
            onChange: _onSelectedEGChange,
            comboBoxOptionStyles: selectStepComboBoxStyle,
            required: true
          }
        ),
        /* @__PURE__ */ jsx(
          SearchDropdownField$1,
          {
            name: "featureIdFromSearch",
            ariaLabel: "feature experiment",
            label: "Feature experiment",
            labelProps: {
              iconProps: __spreadValues({}, UnifiedFeatureSearchInfoIconProps(workspaceId))
            },
            placeholder: isFeaturesListLoading() ? "Loading" : "Select feature experiment",
            options: ((_b = experimentationGroupFeaturesAsync.data) == null ? void 0 : _b.filter((feature) => !!feature.displayName && feature.displayName !== "").map((feature) => ({
              key: feature.id,
              text: feature.displayName,
              data: feature
            }))) || [],
            disabled: !values.experimentationGroup || isFeaturesListLoading(),
            onChange: _onSelectedFeatureChange,
            comboBoxOptionStyles: selectStepComboBoxStyle,
            required: true
          }
        ),
        /* @__PURE__ */ jsxs(StackItem, { children: [
          /* @__PURE__ */ jsx(
            Label,
            {
              htmlFor: "experimentStepSelection",
              text: "Experiment step",
              iconProps: {
                ariaLabel: ExperimentStepLabelInfoIcon.ariaLabel,
                iconName: ExperimentStepLabelInfoIcon.iconName,
                calloutProps: {
                  content: /* @__PURE__ */ jsx(Fragment, { children: ExperimentStepLabelInfoIcon.content })
                }
              },
              required: true
            }
          ),
          /* @__PURE__ */ jsxs(StackItem, { style: { display: "flex" }, children: [
            /* @__PURE__ */ jsx(StackItem, { style: { flexGrow: 6 }, children: /* @__PURE__ */ jsx(
              SearchDropdownField$1,
              {
                name: "experimentStepIdFromSearch",
                ariaLabel: "experiment steps",
                id: "experimentStepSelection",
                options: values.isFeatureRollout ? getExperimentStepsFromProgressions(values.featureIdFromSearch, featureProgressionsAsync.data) : getExperimentStepsFromExperiment(experimentAsync.data),
                placeholder: isFeaturesListLoading() || isFeatureProgressionsLoading() || isExperimentLoading() ? "Loading" : "Select experiment step",
                disabled: !values.featureIdFromSearch || isFeaturesListLoading() || isFeatureProgressionsLoading() || isExperimentLoading(),
                onChange: (e, o) => {
                  setFieldValue("experimentIdFromSearch", o == null ? void 0 : o.data.experimentId);
                },
                comboBoxOptionStyles: selectStepComboBoxStyle,
                required: true
              }
            ) }),
            /* @__PURE__ */ jsx(
              IconButton,
              {
                ariaLabel: "View experiment step",
                text: "View",
                disabled: !values.experimentIdFromSearch,
                onClick: () => viewExperiment(values.experimentIdFromSearch, values.featureIdFromSearch),
                iconProps: { iconName: "OpenInNewTab", ariaLabel: "open experiment in new tab" }
              }
            )
          ] })
        ] })
      ] })
    }
  );
};
const LegacySearchExperiments = () => {
  var _a, _b;
  const dispatch = useDispatch();
  const workspaceId = useSelector(getWorkspaceIdSelector);
  const experimentationGroupsAsync = useSelector((state) => state.maui.global.experimentation_groups);
  const experimentationGroupExperimentsAsync = useSelector(
    (state) => state.maui.draft.experimentation_group_experiments
  );
  const experimentAsync = useSelector((state) => state.maui.draft.experiment);
  const featureProgressionsAsync = useSelector((state) => state.maui.draft.feature_progressions);
  const { values, setFieldValue } = useFormikContext();
  const isExperimentListLoading = () => {
    return (experimentationGroupExperimentsAsync == null ? void 0 : experimentationGroupExperimentsAsync.status) === AsyncRequestStatus.Pending;
  };
  const isExperimentLoading = () => {
    return (experimentAsync == null ? void 0 : experimentAsync.status) === AsyncRequestStatus.Pending;
  };
  const isFeatureProgressionsLoading = () => {
    return (featureProgressionsAsync == null ? void 0 : featureProgressionsAsync.status) === AsyncRequestStatus.Pending;
  };
  const _onSelectedEGChange = (event, option) => {
    var _a2;
    setFieldValue("featureIdFromSearch", "");
    setFieldValue("experimentIdFromSearch", "");
    setFieldValue("experimentStepIdFromSearch", "");
    dispatch(
      loadExperimentsForExperimentationGroupEpicReducer.actionCreators.load({
        workspaceId,
        experimentationGroup: (_a2 = option == null ? void 0 : option.data.path) != null ? _a2 : ""
      })
    );
  };
  const _onSelectedFeatureChange = (event, option) => {
    setFieldValue("experimentIdFromSearch", "");
    setFieldValue("experimentStepIdFromSearch", "");
    const experimentDto = option == null ? void 0 : option.data;
    if (experimentDto.IsFeatureRollout) {
      setFieldValue("isFeatureRollout", true);
      dispatch(
        loadFeatureProgressionsEpicReducer.actionCreators.load({
          featureId: experimentDto.Id
        })
      );
    } else {
      setFieldValue("isFeatureRollout", false);
      dispatch(
        loadExperimentEpicReducer.actionCreators.load({
          experimentId: experimentDto.Id
        })
      );
    }
  };
  return /* @__PURE__ */ jsx(
    ControlTowerLoading,
    {
      useProgressIndicator: false,
      resources: [
        {
          asyncData: experimentationGroupsAsync,
          displayName: "Experimentation Groups",
          onRetry: () => dispatch(loadAllExperimentationGroupsEpicReducer.actionCreators.load({}))
        }
      ],
      children: /* @__PURE__ */ jsxs(FormSection, { children: [
        /* @__PURE__ */ jsx(
          SearchDropdownField$1,
          {
            name: "experimentationGroup",
            ariaLabel: "experimentation group",
            label: "Experimentation group",
            placeholder: "Select experimentation group",
            options: ((_a = experimentationGroupsAsync.data) == null ? void 0 : _a.map((group) => ({
              key: group.id,
              text: group.path,
              data: group
            }))) || [],
            onChange: _onSelectedEGChange,
            comboBoxOptionStyles: selectStepComboBoxStyle,
            required: true
          }
        ),
        /* @__PURE__ */ jsx(
          SearchDropdownField$1,
          {
            name: "featureIdFromSearch",
            ariaLabel: "experiment",
            label: "Experiment",
            labelProps: {
              iconProps: __spreadValues({}, LegacyExperimentSearchInfoIconProps(workspaceId))
            },
            placeholder: isExperimentListLoading() ? "Loading" : "Select experiment",
            options: ((_b = experimentationGroupExperimentsAsync.data) == null ? void 0 : _b.filter((experiment) => !!experiment.Name && experiment.Name !== "").map((experiment) => {
              var _a2;
              return {
                key: experiment.Id,
                text: (_a2 = experiment.Name) != null ? _a2 : "",
                data: experiment
              };
            })) || [],
            disabled: !values.experimentationGroup || isExperimentListLoading(),
            onChange: _onSelectedFeatureChange,
            comboBoxOptionStyles: selectStepComboBoxStyle,
            required: true
          }
        ),
        /* @__PURE__ */ jsxs(StackItem, { children: [
          /* @__PURE__ */ jsx(
            Label,
            {
              htmlFor: "experimentStepSelection",
              text: "Experiment step",
              iconProps: {
                ariaLabel: ExperimentStepLabelInfoIcon.ariaLabel,
                iconName: ExperimentStepLabelInfoIcon.iconName,
                calloutProps: {
                  content: /* @__PURE__ */ jsx(Fragment, { children: ExperimentStepLabelInfoIcon.content })
                }
              },
              required: true
            }
          ),
          /* @__PURE__ */ jsxs(StackItem, { style: { display: "flex" }, children: [
            /* @__PURE__ */ jsx(StackItem, { style: { flexGrow: 6 }, children: /* @__PURE__ */ jsx(
              SearchDropdownField$1,
              {
                name: "experimentStepIdFromSearch",
                ariaLabel: "experiment steps",
                id: "experimentStepSelection",
                options: values.isFeatureRollout ? getExperimentStepsFromProgressions(values.featureIdFromSearch, featureProgressionsAsync.data) : getExperimentStepsFromExperiment(experimentAsync.data),
                placeholder: isExperimentListLoading() || isFeatureProgressionsLoading() || isExperimentLoading() ? "Loading" : "Select experiment step",
                disabled: !values.featureIdFromSearch || isExperimentListLoading() || isFeatureProgressionsLoading() || isExperimentLoading(),
                onChange: (e, o) => {
                  setFieldValue("experimentIdFromSearch", o == null ? void 0 : o.data.experimentId);
                },
                comboBoxOptionStyles: selectStepComboBoxStyle,
                required: true
              }
            ) }),
            /* @__PURE__ */ jsx(
              IconButton,
              {
                ariaLabel: "View experiment step",
                text: "View",
                disabled: !values.experimentIdFromSearch,
                onClick: () => viewExperiment(values.experimentIdFromSearch, values.featureIdFromSearch),
                iconProps: { iconName: "OpenInNewTab", ariaLabel: "open experiment in new tab" }
              }
            )
          ] })
        ] })
      ] })
    }
  );
};
const DefaultExperimentStepsSelection = (props) => {
  const dispatch = useDispatch();
  const [selectedExperimentStep, setSelectedExperimentStep] = useState();
  const { values, setFieldValue } = useFormikContext();
  const metricSetConfig = useSelector((state) => state.maui.drafts.metric_set_config);
  const defaultExperiments = useSelector((state) => state.maui.draft.default_experiments);
  const defaultFeatures = useSelector((state) => state.maui.draft.default_features);
  const experimentPlanSummaries = useSelector((state) => state.maui.draft.experiment_plan_summaries);
  useEffect(() => {
    if (!!(selectedExperimentStep == null ? void 0 : selectedExperimentStep.experimentId)) {
      setFieldValue("experimentIdFromDefaultSteps", selectedExperimentStep == null ? void 0 : selectedExperimentStep.experimentId);
    }
    if (!!(selectedExperimentStep == null ? void 0 : selectedExperimentStep.featureId)) {
      setFieldValue("featureIdFromDefaultSteps", selectedExperimentStep == null ? void 0 : selectedExperimentStep.featureId);
    }
  }, [setFieldValue, selectedExperimentStep]);
  return /* @__PURE__ */ jsx(
    ControlTowerLoading,
    {
      useProgressIndicator: false,
      resources: [
        {
          asyncData: metricSetConfig,
          displayName: "metric set config",
          onRetry: () => dispatch(loadMetricSetConfigEpicReducer.actionCreators.load({ metricSetName: props.selectedMetricSetName }))
        },
        {
          asyncData: experimentPlanSummaries,
          displayName: "default experiment steps",
          onRetry: () => {
            var _a;
            return dispatch(
              loadExperimentStepPlanSummariesEpicReducer.actionCreators.load({
                stepIds: ((_a = metricSetConfig.data) == null ? void 0 : _a.defaultExperimentStepsForPreviewScorecard) || []
              })
            );
          }
        },
        {
          asyncData: defaultExperiments,
          displayName: "default experiments"
        },
        {
          asyncData: defaultFeatures,
          displayName: "default features"
        }
      ],
      children: /* @__PURE__ */ jsxs(StackItem, { children: [
        /* @__PURE__ */ jsx(
          Label,
          {
            htmlFor: "defaultExperimentStepSelection",
            text: "Experiment step",
            iconProps: {
              ariaLabel: DefaultExperimentStepLabelInfoIcon.ariaLabel,
              iconName: DefaultExperimentStepLabelInfoIcon.iconName,
              calloutProps: {
                content: /* @__PURE__ */ jsx(Fragment, { children: DefaultExperimentStepLabelInfoIcon.content })
              }
            },
            required: true
          }
        ),
        /* @__PURE__ */ jsxs(StackItem, { style: { display: "flex" }, children: [
          /* @__PURE__ */ jsx(StackItem, { style: { flexGrow: 6 }, children: /* @__PURE__ */ jsx(
            SearchDropdownField,
            {
              placeholder: "Select a default experiment step",
              name: "defaultExperimentStepId",
              id: "defaultExperimentStepSelection",
              ariaLabel: "Please select a default experiment step",
              options: props.options,
              calloutProps: {
                calloutMaxHeight: 300
              },
              onChange: (ev, option) => {
                setSelectedExperimentStep(option == null ? void 0 : option.data);
              },
              comboBoxOptionStyles: selectStepComboBoxStyle
            }
          ) }),
          /* @__PURE__ */ jsx(
            IconButton,
            {
              ariaLabel: "View experiment step",
              text: "View",
              disabled: !values.experimentIdFromDefaultSteps,
              onClick: () => viewExperiment(values.experimentIdFromDefaultSteps, values.featureIdFromDefaultSteps),
              iconProps: { iconName: "OpenInNewTab", ariaLabel: "open experiment in new tab" }
            }
          )
        ] })
      ] })
    }
  );
};
var ExperimentStepOption = /* @__PURE__ */ ((ExperimentStepOption2) => {
  ExperimentStepOption2["recentPreviewScorecardSteps"] = "recentPreviewScorecardSteps";
  ExperimentStepOption2["defaultExperiments"] = "defaultExperiments";
  ExperimentStepOption2["searchExperiments"] = "searchExperiments";
  return ExperimentStepOption2;
})(ExperimentStepOption || {});
const CreatePreviewScorecardForm = (props) => {
  var _a, _b, _c;
  const { selectedMetricSetName, selectedMetricSetVersion, panelProps, draftName } = props;
  const workspaceId = useSelector(getWorkspaceIdSelector);
  const recentPreviewAnalysis = useSelector((state) => state.maui.draft.recent_preview_analyses);
  const recentExperiments = useSelector((state) => state.maui.draft.recent_experiments);
  const recentFeatures = useSelector((state) => state.maui.draft.recent_features);
  const experimentationGroupExperimentsAsync = useSelector(
    (state) => state.maui.draft.experimentation_group_experiments
  );
  const experimentationGroupFeaturesAsync = useSelector((state) => state.maui.draft.experimentation_group_features);
  const experimentAsync = useSelector((state) => state.maui.draft.experiment);
  const featureProgressionsAsync = useSelector((state) => state.maui.draft.feature_progressions);
  const metricSetConfig = useSelector((state) => state.maui.drafts.metric_set_config);
  const defaultExperiments = useSelector((state) => state.maui.draft.default_experiments);
  const defaultFeatures = useSelector((state) => state.maui.draft.default_features);
  const experimentPlanSummaries = useSelector((state) => state.maui.draft.experiment_plan_summaries);
  const experimentStepExperimentsMapping = (_b = (_a = experimentPlanSummaries.data) == null ? void 0 : _a.filter((experimentPlan) => inCurrentWorkspaceFilter(experimentPlan, workspaceId)).map((experimentPlan) => {
    return {
      [Object.keys(experimentPlan)[0]]: Object.values(experimentPlan)[0].Id
    };
  })) != null ? _b : [];
  const defaultExperimentStepOptions = getExperimentStepsOptions(
    experimentStepExperimentsMapping,
    defaultExperiments,
    defaultFeatures
  );
  const initialValues = {
    selectedMetricSetName,
    selectedMetricSetVersion,
    isFeatureRollout: true,
    experimentStepOption: (((_c = metricSetConfig.data) == null ? void 0 : _c.defaultExperimentStepsForPreviewScorecard) || []).length > 0 ? "defaultExperiments" : getRecentExperimentStepsOptions(recentPreviewAnalysis, recentExperiments, recentFeatures, workspaceId).length > 0 ? "recentPreviewScorecardSteps" : "searchExperiments"
    /* searchExperiments */
  };
  const choiceGroupOptions = [
    {
      key: "defaultExperiments",
      text: "Default experiment steps"
    },
    {
      key: "recentPreviewScorecardSteps",
      text: "Recent experiment steps",
      styles: { choiceFieldWrapper: { marginLeft: "10px" } }
    },
    {
      key: "searchExperiments",
      text: "Search experiments",
      styles: { choiceFieldWrapper: { marginLeft: "10px" } }
    }
  ];
  const [result, setResult] = useState(getDefaultAsyncWrapperObj());
  const { completePendingWork } = useContext(ScenarioLoggingContext);
  const logPreviewScorecardExperimentStepOption = (payload) => {
    Logger.trackMetric({
      name: MAUI_METRIC_LOG.PREVIEW_SCORECARD_STEP_SELECTION_OPTION,
      average: 1,
      properties: {
        [previewScorecardLogProperties.url]: document.location.href || "urlundefined",
        [previewScorecardLogProperties.isUnifiedView]: EnvironmentService.isUnifiedView,
        [previewScorecardLogProperties.experimentStepOption]: payload.stepOption,
        [previewScorecardLogProperties.experimentStepId]: payload.stepId,
        [previewScorecardLogProperties.metricSetName]: selectedMetricSetName,
        [previewScorecardLogProperties.draftName]: draftName,
        [previewScorecardLogProperties.metricSetVersion]: selectedMetricSetVersion
      }
    });
  };
  const _validateForm = React.useCallback(
    (values) => validateForm({
      values,
      experimentationGroupFeaturesAsync,
      featureProgressionsAsync,
      experimentationGroupExperimentsAsync,
      experimentAsync,
      recentExperimentStepOptions: getRecentExperimentStepsOptions(
        recentPreviewAnalysis,
        recentExperiments,
        recentFeatures,
        workspaceId
      ),
      defaultExperimentStepOptions
    }),
    [
      experimentationGroupFeaturesAsync,
      featureProgressionsAsync,
      experimentationGroupExperimentsAsync,
      experimentAsync,
      recentPreviewAnalysis,
      recentExperiments,
      recentFeatures,
      workspaceId
    ]
  );
  const _onRenderSaveButton = ({ disabled, formId, onClick }) => {
    return /* @__PURE__ */ jsx(
      IconButton,
      {
        ariaLabel: CreateAnalysisButton.ariaLabel,
        disabled,
        text: CreateAnalysisButton.text,
        form: formId,
        iconProps: CreateAnalysisButton.iconProps,
        onClick
      }
    );
  };
  const _renderFormFields = () => {
    const { values } = useFormikContext();
    const workspaceId2 = useSelector(getWorkspaceIdSelector);
    const dispatch = useDispatch();
    const getExperimentStepSelectionView = () => {
      if (values.experimentStepOption === "searchExperiments") {
        if (EnvironmentService.isUnifiedView) {
          return /* @__PURE__ */ jsx(UnifiedSearchExperiments, {});
        }
        return /* @__PURE__ */ jsx(LegacySearchExperiments, {});
      } else if (values.experimentStepOption === "defaultExperiments") {
        return /* @__PURE__ */ jsx(DefaultExperimentStepsSelection, { options: defaultExperimentStepOptions, selectedMetricSetName });
      }
      return /* @__PURE__ */ jsx(RecentExperimentStepsSelection, {});
    };
    useEffect(() => {
      var _a2;
      dispatch(
        loadRecentPreviewAnalysisEpicReducer.actionCreators.load({
          getExperimentSteps: true,
          metricSetName: selectedMetricSetName
        })
      );
      dispatch(loadAllExperimentationGroupsEpicReducer.actionCreators.load({}));
      dispatch(
        loadExperimentStepPlanSummariesEpicReducer.actionCreators.load({
          stepIds: ((_a2 = metricSetConfig.data) == null ? void 0 : _a2.defaultExperimentStepsForPreviewScorecard) || []
        })
      );
    }, [dispatch]);
    return /* @__PURE__ */ jsx(FormSection, { children: /* @__PURE__ */ jsxs(Stack, { verticalAlign: "start", children: [
      /* @__PURE__ */ jsxs(StackItem$1, { children: [
        "To generate your preview scorecard, please choose an experiment step. If you're having trouble finding the right experiment step, you can visit the",
        " ",
        /* @__PURE__ */ jsx(
          ExternalLink,
          {
            text: EnvironmentService.isUnifiedView ? "feature list page" : "experiment list page",
            href: getSearchURL(workspaceId2),
            iconProps: { iconName: "OpenInNewWindow", ariaLabel: "open workspace selection doc in new tab" },
            onClick: () => logPreviewScorecardExperimentStepOption({ stepOption: "searchFeatureHomePage" })
          }
        ),
        " ",
        "to locate it and create a preview analysis. ",
        /* @__PURE__ */ jsx(LearnMoreLink, __spreadValues({}, PreviewFromExperimentStepLinkProps))
      ] }),
      /* @__PURE__ */ jsx(StackItem$1, { children: /* @__PURE__ */ jsx(
        ChoiceGroupField,
        {
          name: "experimentStepOption",
          ariaLabel: "Choose your experiment step option",
          styles: { flexContainer: { display: "flex" } },
          options: choiceGroupOptions
        }
      ) }),
      getExperimentStepSelectionView()
    ] }) });
  };
  const _renderFormHeader = () => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Heading, { tag: "h2", children: "Select experiment step" }) });
  return /* @__PURE__ */ jsx(
    CreateEntityPanel,
    __spreadValues({
      isOpen: true,
      response: result,
      formikConfig: {
        initialValues,
        onSubmit: (values) => {
          var _a2, _b2, _c2;
          const stepId = values.experimentStepOption === "recentPreviewScorecardSteps" ? (_a2 = values.experimentStepIdFromRecentAnalyses) != null ? _a2 : "" : values.experimentStepOption === "defaultExperiments" ? (_b2 = values.defaultExperimentStepId) != null ? _b2 : "" : (_c2 = values.experimentStepIdFromSearch) != null ? _c2 : "";
          logPreviewScorecardExperimentStepOption({ stepOption: values.experimentStepOption, stepId });
          completePendingWork(MetricsAuthoringScenarioLoggingNames.PreviewScorecard_SelectExperimentStep, {
            [previewScorecardLogProperties.experimentStepOption]: values.experimentStepOption,
            [previewScorecardLogProperties.experimentStepId]: stepId,
            [previewScorecardLogProperties.metricSetName]: values.selectedMetricSetName,
            [previewScorecardLogProperties.draftName]: draftName,
            [previewScorecardLogProperties.metricSetVersion]: values.selectedMetricSetVersion
          });
          NavigationService.openLinkInNewTab(
            getPreviewAnalysisStudyCreateURL({
              stepId,
              metricSetName: values.selectedMetricSetName,
              metricSetVersion: values.selectedMetricSetVersion
            })
          );
          setResult({ status: AsyncRequestStatus.Completed });
        },
        validate: _validateForm
      },
      renderFormHeader: _renderFormHeader,
      renderFormFields: _renderFormFields,
      onRenderSaveButton: _onRenderSaveButton,
      entityManagementGroupFieldName: CREATE_METRIC_SET_FIELDS.experimentationGroup.name
    }, panelProps)
  );
};
const isFeatureRollout = (payload) => {
  return payload.featureId !== defaultGuid;
};
const getRecentExperimentStepsOptions = (recentPreviewAnalysis, recentExperiments, recentFeatures, workspaceId) => {
  var _a, _b, _c;
  const recentPreviewAnalysisInWorkspace = (_b = (_a = recentPreviewAnalysis.data) == null ? void 0 : _a.value) == null ? void 0 : _b.filter(
    (analysis) => analysis.experimentMetadata.workspaceId === workspaceId
  );
  const uniqueExperimentStepAnalyses = recentPreviewAnalysisInWorkspace == null ? void 0 : recentPreviewAnalysisInWorkspace.filter(
    (analysis, index, currArray) => currArray.map((currAnalysis) => currAnalysis.experimentMetadata.experimentStepId).indexOf(analysis.experimentMetadata.experimentStepId) === index
  );
  const experimentStepExperimentMapping = (_c = uniqueExperimentStepAnalyses == null ? void 0 : uniqueExperimentStepAnalyses.map((uniqueExperimentStepAnalysis) => {
    return {
      [uniqueExperimentStepAnalysis.experimentMetadata.experimentStepId]: uniqueExperimentStepAnalysis.experimentMetadata.experimentId || ""
    };
  })) != null ? _c : [];
  const options = getExperimentStepsOptions(experimentStepExperimentMapping, recentExperiments, recentFeatures);
  return options != null ? options : [];
};
const getExperimentStepName = (payload) => {
  const { flightTraffic, startTime } = payload;
  let experimentStepName = `${flightTraffic.shift()}`;
  flightTraffic.forEach((trafficPercentage) => {
    experimentStepName = `${experimentStepName}-${trafficPercentage}`;
  });
  return `${experimentStepName} Step ${getStartTimeDisplayText(startTime)}`;
};
const getStartTimeDisplayText = (startTime) => {
  const reformattedStartTime = !!startTime ? startTime.replace(/[-:T]/g, "") : "";
  return !!startTime ? `: ${parseDate(reformattedStartTime).toUTCString()}` : "";
};
const getExperimentStepsFromProgressions = (featureId, progressions) => {
  let experimentSteps = [];
  if (!!progressions) {
    progressions.forEach((progression) => {
      var _a;
      (_a = progression.Studies) == null ? void 0 : _a.forEach((study) => {
        var _a2;
        (_a2 = study.Stages) == null ? void 0 : _a2.forEach((stage) => {
          var _a3, _b, _c, _d, _e, _f;
          if (((_a3 = stage.State) == null ? void 0 : _a3.toLowerCase()) !== ExperimentStates.NEW) {
            if (((_b = stage.ParallelSteps) == null ? void 0 : _b[0].Type) === ExperimentStepType.AB) {
              const flightTraffic = Object.values((_d = (_c = stage.ParallelSteps) == null ? void 0 : _c[0].FlightTrafficMap) != null ? _d : {});
              const startTime = stage.StartTime;
              if (flightTraffic.length > 1) {
                const stepId = (_e = stage.ParallelSteps) == null ? void 0 : _e[0].Id;
                const text = `${progression.Name} : ${study.Name} : ${getExperimentStepName({ flightTraffic, startTime })}`;
                experimentSteps.push({
                  key: stepId != null ? stepId : "",
                  text,
                  data: {
                    stepId,
                    featureId: featureId != null ? featureId : "",
                    experimentId: (_f = study == null ? void 0 : study.Id) != null ? _f : ""
                  }
                });
              }
            }
          }
        });
      });
    });
  }
  return experimentSteps;
};
const getExperimentStepsFromExperiment = (experiment) => {
  let experimentSteps = [];
  if (!!experiment) {
    experiment.experimentSteps.forEach((experimentStep) => {
      var _a, _b;
      if (!!(experimentStep == null ? void 0 : experimentStep.variantTrafficMaps) && (experimentStep == null ? void 0 : experimentStep.variantTrafficMaps.length) > 1 && !!experimentStep.startedAt) {
        const startTime = experimentStep == null ? void 0 : experimentStep.startedAt;
        const experimentStepName = `${experimentStep == null ? void 0 : experimentStep.variantTrafficMaps[0].trafficExposurePercentage}-${experimentStep == null ? void 0 : experimentStep.variantTrafficMaps[1].trafficExposurePercentage} Step ${getStartTimeDisplayText(startTime)}`;
        const text = `${experiment == null ? void 0 : experiment.displayName} : ${experimentStepName}`;
        experimentSteps.push({
          key: experimentStep.id,
          text,
          data: {
            stepId: experimentStep.id,
            featureId: (_a = experiment == null ? void 0 : experiment.featureId) != null ? _a : "",
            experimentId: (_b = experiment == null ? void 0 : experiment.id) != null ? _b : ""
          }
        });
      }
    });
  }
  return experimentSteps;
};
const getSearchURL = (workspaceId) => {
  let path = EnvironmentService.isUnifiedView ? `${NavigationService.root.url}${ROUTES.featureSearch.root.location.pathname}` : ExperimentSearchRouteUtils.routes.experimentSearch.url();
  const params = [];
  params.push(`${WORKSPACE_ID}=${workspaceId}`);
  return path += `?${params.join("&")}`;
};
const getPreviewAnalysisStudyCreateURL = (payload) => {
  let path = GarRouteUtils.routes.create.url({ stepId: payload.stepId });
  const params = [];
  params.push(`metricSetName=${payload.metricSetName}`);
  params.push(`metricSetVersionName=${payload.metricSetVersion}`);
  return path += `?${params.join("&")}`;
};
const viewExperiment = (experimentId, featureId) => {
  if (experimentId === featureId || featureId === defaultGuid) {
    if (!!experimentId) {
      NavigationService.openLinkInNewTab(getExperimentUrl(experimentId));
    }
  } else {
    if (!!experimentId && !!featureId)
      NavigationService.openLinkInNewTab(
        FeatureProgressionRouteUtils.routes.progressionStageView.getURL(featureId, [experimentId])
      );
  }
};
const parseDate = (date) => {
  const year = Number.parseInt(date.substring(0, 4));
  const month = Number.parseInt(date.substring(4, 6)) - 1;
  const day = Number.parseInt(date.substring(6, 8));
  const hours = Number.parseInt(date.substring(8, 10));
  const minutes = Number.parseInt(date.substring(10, 12));
  const seconds = Number.parseInt(date.substring(12, 14));
  return new Date(Date.UTC(year, month, day, hours, minutes, seconds));
};
const getDraftFromPublishedVersion = (publishedVersion) => {
  let version = publishedVersion != null ? publishedVersion : "";
  const hyphen = "-";
  if (version.indexOf(hyphen) === -1) {
    return version;
  } else {
    for (let i = 0; i < 3; i++) {
      version = version.substring(0, version.lastIndexOf(hyphen));
    }
    return version.substring(version.indexOf(hyphen) + 1).replace(/-/gi, "_");
  }
};
const getDraftFromAnalysisMetricSetVersion = (metricSetVersion) => {
  let version = metricSetVersion != null ? metricSetVersion : "";
  return version.substring(version.lastIndexOf("_") + 1);
};
const validateRecentExperiments = (payload) => {
  const { values, recentExperimentStepOptions } = payload;
  let errors = {};
  if (!values.experimentStepIdFromRecentAnalyses) {
    errors.experimentStepIdFromRecentAnalyses = CREATE_PREVIEW_SCORECARD.experimentStepId.validation.required.message;
  }
  if (recentExperimentStepOptions.length === 0) {
    errors.experimentStepIdFromRecentAnalyses = CREATE_PREVIEW_SCORECARD.experimentStepId.validation.empty.message;
  }
  return errors;
};
const validateDefaultExperiments = (payload) => {
  const { values, defaultExperimentStepOptions } = payload;
  let errors = {};
  if (!values.defaultExperimentStepId) {
    errors.defaultExperimentStepId = CREATE_PREVIEW_SCORECARD.experimentStepId.validation.required.message;
  }
  if (defaultExperimentStepOptions.length === 0) {
    errors.defaultExperimentStepId = CREATE_PREVIEW_SCORECARD.experimentStepId.validation.empty.message;
  }
  return errors;
};
const validateUnifiedExperiments = (payload) => {
  var _a;
  const { values, experimentationGroupFeaturesAsync, featureProgressionsAsync } = payload;
  let errors = {};
  if (!values.experimentationGroup) {
    errors.experimentationGroup = CREATE_PREVIEW_SCORECARD.experimentationGroup.validation.required.message;
  } else {
    if (!values.featureIdFromSearch) {
      errors.featureIdFromSearch = CREATE_PREVIEW_SCORECARD.featureId.validation.required.message;
    } else {
      if (!values.experimentStepIdFromSearch) {
        errors.experimentStepIdFromSearch = CREATE_PREVIEW_SCORECARD.experimentStepId.validation.required.message;
      }
      if (featureProgressionsAsync.status === AsyncRequestStatus.Completed) {
        const progressions = getExperimentStepsFromProgressions(values.featureIdFromSearch, featureProgressionsAsync.data);
        if (progressions.length === 0) {
          errors.experimentStepIdFromSearch = CREATE_PREVIEW_SCORECARD.experimentStepId.validation.empty.message;
        }
      }
    }
    if (experimentationGroupFeaturesAsync.status === AsyncRequestStatus.Completed) {
      if (((_a = experimentationGroupFeaturesAsync.data) == null ? void 0 : _a.length) === 0) {
        errors.featureIdFromSearch = CREATE_PREVIEW_SCORECARD.featureId.validation.empty.message;
      }
    }
  }
  return errors;
};
const validateLegacyExperiments = (payload) => {
  var _a;
  const { values, experimentationGroupExperimentsAsync, experimentAsync, featureProgressionsAsync } = payload;
  let errors = {};
  if (!values.experimentationGroup) {
    errors.experimentationGroup = CREATE_PREVIEW_SCORECARD.experimentationGroup.validation.required.message;
  } else {
    if (!values.featureIdFromSearch) {
      errors.featureIdFromSearch = CREATE_PREVIEW_SCORECARD.featureId.validation.required.message;
    } else {
      if (!values.experimentStepIdFromSearch) {
        errors.experimentStepIdFromSearch = CREATE_PREVIEW_SCORECARD.experimentStepId.validation.required.message;
      }
      if (values.isFeatureRollout && featureProgressionsAsync.status === AsyncRequestStatus.Completed) {
        const progressions = getExperimentStepsFromProgressions(values.featureIdFromSearch, featureProgressionsAsync.data);
        if (progressions.length === 0) {
          errors.experimentStepIdFromSearch = CREATE_PREVIEW_SCORECARD.experimentStepId.validation.empty.message;
        }
      } else if (!values.isFeatureRollout && experimentAsync.status === AsyncRequestStatus.Completed) {
        const experiments = getExperimentStepsFromExperiment(experimentAsync.data);
        if (experiments.length === 0) {
          errors.experimentStepIdFromSearch = CREATE_PREVIEW_SCORECARD.experimentStepId.validation.empty.message;
        }
      }
    }
    if (experimentationGroupExperimentsAsync.status === AsyncRequestStatus.Completed && ((_a = experimentationGroupExperimentsAsync.data) == null ? void 0 : _a.length) === 0) {
      errors.featureIdFromSearch = CREATE_PREVIEW_SCORECARD.featureId.validation.empty.message;
    }
  }
  return errors;
};
const validateForm = (payload) => {
  const {
    values,
    experimentationGroupFeaturesAsync,
    featureProgressionsAsync,
    experimentationGroupExperimentsAsync,
    experimentAsync,
    recentExperimentStepOptions,
    defaultExperimentStepOptions
  } = payload;
  let errors = {};
  if (!!values.experimentStepOption) {
    if (values.experimentStepOption === ExperimentStepOption.recentPreviewScorecardSteps) {
      errors = validateRecentExperiments({ values, recentExperimentStepOptions });
    } else if (values.experimentStepOption === ExperimentStepOption.defaultExperiments) {
      errors = validateDefaultExperiments({ values, defaultExperimentStepOptions });
    } else if (EnvironmentService.isUnifiedView) {
      errors = validateUnifiedExperiments({ values, experimentationGroupFeaturesAsync, featureProgressionsAsync });
    } else {
      errors = validateLegacyExperiments({
        values,
        experimentationGroupExperimentsAsync,
        experimentAsync,
        featureProgressionsAsync
      });
    }
  }
  return errors;
};
const getExperimentStepsOptions = (experimentStepExperimentMapping, experiments, features) => {
  return experimentStepExperimentMapping == null ? void 0 : experimentStepExperimentMapping.map((stepExperimentMapping) => {
    var _a, _b, _c;
    const stepId = Object.keys(stepExperimentMapping)[0];
    const experimentId = Object.values(stepExperimentMapping)[0];
    const experiment = ___default.find(experiments.data, (experiment2) => experiment2.id === experimentId);
    const experimentStep = ___default.find(experiment == null ? void 0 : experiment.experimentSteps, (experimentStep2) => experimentStep2.id === stepId);
    const startTime = experimentStep == null ? void 0 : experimentStep.startedAt;
    const experimentStepName = !!(experimentStep == null ? void 0 : experimentStep.variantTrafficMaps) && (experimentStep == null ? void 0 : experimentStep.variantTrafficMaps.length) > 1 ? `${experimentStep == null ? void 0 : experimentStep.variantTrafficMaps[0].trafficExposurePercentage}-${experimentStep == null ? void 0 : experimentStep.variantTrafficMaps[1].trafficExposurePercentage} Step ${getStartTimeDisplayText(startTime)}` : `${experimentStep == null ? void 0 : experimentStep.displayName} ${getStartTimeDisplayText(startTime)}`;
    let text = "";
    if (isFeatureRollout({ featureId: (_a = experiment == null ? void 0 : experiment.featureId) != null ? _a : "" }) && (experiment == null ? void 0 : experiment.featureId) !== (experiment == null ? void 0 : experiment.id)) {
      const feature = ___default.find(features.data, (feature2) => feature2.id === (experiment == null ? void 0 : experiment.featureId));
      text = `${feature == null ? void 0 : feature.displayName} : ${experiment == null ? void 0 : experiment.displayName} : ${experimentStepName}`;
    } else {
      text = `${experiment == null ? void 0 : experiment.displayName} : ${experimentStepName}`;
    }
    return {
      key: stepId,
      text,
      data: {
        stepId,
        featureId: (_b = experiment == null ? void 0 : experiment.featureId) != null ? _b : "",
        experimentId: (_c = experiment == null ? void 0 : experiment.id) != null ? _c : ""
      }
    };
  });
};
const inCurrentWorkspaceFilter = (experiment, workspaceId) => {
  var _a, _b, _c, _d;
  const featureUrl = (_b = (_a = Object.values(experiment)[0]) == null ? void 0 : _a.FeatureUrl) != null ? _b : "";
  const workspaceIdFromUrl = (_d = (_c = featureUrl.match(new RegExp("(?<=workspaceId=).+$"))) == null ? void 0 : _c.at(0)) != null ? _d : "";
  return !workspaceIdFromUrl || workspaceIdFromUrl === workspaceId;
};
var ROOT_REDUCER_KEYS = /* @__PURE__ */ ((ROOT_REDUCER_KEYS2) => {
  ROOT_REDUCER_KEYS2["global"] = "global";
  ROOT_REDUCER_KEYS2["metric_sets"] = "metric_sets";
  ROOT_REDUCER_KEYS2["drafts"] = "drafts";
  ROOT_REDUCER_KEYS2["draft"] = "draft";
  return ROOT_REDUCER_KEYS2;
})(ROOT_REDUCER_KEYS || {});
var GLOBAL_REDUCER_KEYS = /* @__PURE__ */ ((GLOBAL_REDUCER_KEYS2) => {
  GLOBAL_REDUCER_KEYS2["experimentation_groups_with_metric_write"] = "experimentation_groups_with_metric_write";
  GLOBAL_REDUCER_KEYS2["experimentation_groups"] = "experimentation_groups";
  GLOBAL_REDUCER_KEYS2["user_access"] = "user_access";
  GLOBAL_REDUCER_KEYS2["user_metric_write_access"] = "user_metric_write_access";
  return GLOBAL_REDUCER_KEYS2;
})(GLOBAL_REDUCER_KEYS || {});
var METRIC_SETS_REDUCER_KEYS = /* @__PURE__ */ ((METRIC_SETS_REDUCER_KEYS2) => {
  METRIC_SETS_REDUCER_KEYS2["list"] = "list";
  METRIC_SETS_REDUCER_KEYS2["create"] = "create";
  METRIC_SETS_REDUCER_KEYS2["clone"] = "clone";
  METRIC_SETS_REDUCER_KEYS2["delete"] = "delete";
  METRIC_SETS_REDUCER_KEYS2["workspace_config"] = "workspace_config";
  METRIC_SETS_REDUCER_KEYS2["metric_set_instance_create"] = "metric_set_instance_create";
  METRIC_SETS_REDUCER_KEYS2["metric_set_instance_status"] = "metric_set_instance_status";
  METRIC_SETS_REDUCER_KEYS2["metric_set_instance_latest_status"] = "metric_set_instance_latest_status";
  return METRIC_SETS_REDUCER_KEYS2;
})(METRIC_SETS_REDUCER_KEYS || {});
var DRAFTS_REDUCER_KEYS = /* @__PURE__ */ ((DRAFTS_REDUCER_KEYS2) => {
  DRAFTS_REDUCER_KEYS2["meta_data"] = "meta_data";
  DRAFTS_REDUCER_KEYS2["history"] = "history";
  DRAFTS_REDUCER_KEYS2["list"] = "list";
  DRAFTS_REDUCER_KEYS2["create"] = "create";
  DRAFTS_REDUCER_KEYS2["delete"] = "delete";
  DRAFTS_REDUCER_KEYS2["metric_set_config"] = "metric_set_config";
  DRAFTS_REDUCER_KEYS2["metric_set_config_update"] = "metric_set_config_update";
  DRAFTS_REDUCER_KEYS2["aggregation_levels"] = "aggregation_levels";
  return DRAFTS_REDUCER_KEYS2;
})(DRAFTS_REDUCER_KEYS || {});
var DRAFT_REDUCER_KEYS = /* @__PURE__ */ ((DRAFT_REDUCER_KEYS2) => {
  DRAFT_REDUCER_KEYS2["history"] = "history";
  DRAFT_REDUCER_KEYS2["raw_columns"] = "raw_columns";
  DRAFT_REDUCER_KEYS2["aggregation_levels"] = "aggregation_levels";
  DRAFT_REDUCER_KEYS2["experiment_config"] = "experiment_config";
  DRAFT_REDUCER_KEYS2["meta_data"] = "meta_data";
  DRAFT_REDUCER_KEYS2["scorecard_layouts"] = "scorecard_layouts";
  DRAFT_REDUCER_KEYS2["computation_templates"] = "computation_templates";
  DRAFT_REDUCER_KEYS2["computation_template_instances"] = "computation_template_instances";
  DRAFT_REDUCER_KEYS2["computation_template_instance_metrics"] = "computation_template_instance_metrics";
  DRAFT_REDUCER_KEYS2["scorecard_layout_paths"] = "scorecard_layout_paths";
  DRAFT_REDUCER_KEYS2["merge"] = "merge";
  DRAFT_REDUCER_KEYS2["merge_update"] = "merge_update";
  DRAFT_REDUCER_KEYS2["validate"] = "validate";
  DRAFT_REDUCER_KEYS2["validate_result"] = "validate_result";
  DRAFT_REDUCER_KEYS2["metrics"] = "metrics";
  DRAFT_REDUCER_KEYS2["metric_health"] = "metric_health";
  DRAFT_REDUCER_KEYS2["publish"] = "publish";
  DRAFT_REDUCER_KEYS2["publish_update"] = "publish_update";
  DRAFT_REDUCER_KEYS2["publish_status"] = "publish_status";
  DRAFT_REDUCER_KEYS2["published_versions"] = "published_versions";
  DRAFT_REDUCER_KEYS2["recent_preview_analyses"] = "recent_preview_analyses";
  DRAFT_REDUCER_KEYS2["experiment"] = "experiment";
  DRAFT_REDUCER_KEYS2["recent_experiments"] = "recent_experiments";
  DRAFT_REDUCER_KEYS2["feature_progressions"] = "feature_progressions";
  DRAFT_REDUCER_KEYS2["recent_features"] = "recent_features";
  DRAFT_REDUCER_KEYS2["default_experiments"] = "default_experiments";
  DRAFT_REDUCER_KEYS2["default_features"] = "default_features";
  DRAFT_REDUCER_KEYS2["experimentation_group_features"] = "experimentation_group_features";
  DRAFT_REDUCER_KEYS2["experimentation_group_experiments"] = "experimentation_group_experiments";
  DRAFT_REDUCER_KEYS2["experiment_plan_summaries"] = "experiment_plan_summaries";
  DRAFT_REDUCER_KEYS2["experiment_steps_validate_result"] = "experiment_steps_validate_result";
  DRAFT_REDUCER_KEYS2["segments"] = "segments";
  DRAFT_REDUCER_KEYS2["computation_file_paths"] = "computation_file_paths";
  DRAFT_REDUCER_KEYS2["columns"] = "columns";
  DRAFT_REDUCER_KEYS2["quick_validate"] = "quick_validate";
  return DRAFT_REDUCER_KEYS2;
})(DRAFT_REDUCER_KEYS || {});
var SEGMENTS_REDUCER_KEYS = /* @__PURE__ */ ((SEGMENTS_REDUCER_KEYS2) => {
  SEGMENTS_REDUCER_KEYS2["list"] = "list";
  SEGMENTS_REDUCER_KEYS2["load"] = "load";
  SEGMENTS_REDUCER_KEYS2["create_get"] = "create_get";
  SEGMENTS_REDUCER_KEYS2["create_put"] = "create_put";
  SEGMENTS_REDUCER_KEYS2["delete"] = "delete";
  return SEGMENTS_REDUCER_KEYS2;
})(SEGMENTS_REDUCER_KEYS || {});
var METRICS_REDUCER_KEYS = /* @__PURE__ */ ((METRICS_REDUCER_KEYS2) => {
  METRICS_REDUCER_KEYS2["list"] = "list";
  METRICS_REDUCER_KEYS2["load"] = "load";
  METRICS_REDUCER_KEYS2["create_get"] = "create_get";
  METRICS_REDUCER_KEYS2["create_put"] = "create_put";
  METRICS_REDUCER_KEYS2["delete"] = "delete";
  return METRICS_REDUCER_KEYS2;
})(METRICS_REDUCER_KEYS || {});
var COLUMN_REDUCER_KEYS = /* @__PURE__ */ ((COLUMN_REDUCER_KEYS2) => {
  COLUMN_REDUCER_KEYS2["list"] = "list";
  COLUMN_REDUCER_KEYS2["load"] = "load";
  return COLUMN_REDUCER_KEYS2;
})(COLUMN_REDUCER_KEYS || {});
var METRIC_HEALTH_REDUCER_KEYS = /* @__PURE__ */ ((METRIC_HEALTH_REDUCER_KEYS2) => {
  METRIC_HEALTH_REDUCER_KEYS2["stat_sig_check"] = "stat_sig_check";
  return METRIC_HEALTH_REDUCER_KEYS2;
})(METRIC_HEALTH_REDUCER_KEYS || {});
const REDUCER_KEYS = {
  [
    "global"
    /* global */
  ]: {
    experimentation_groups_with_metric_write: "experimentation_groups_with_metric_write",
    experimentation_groups: "experimentation_groups",
    user_metric_write_access: "user_metric_write_access"
  },
  [
    "metric_sets"
    /* metric_sets */
  ]: {
    list: "list",
    create: "create",
    clone: "clone",
    delete: "delete",
    workspace_config: "workspace_config",
    metric_set_instance_create: "metric_set_instance_create",
    metric_set_instance_status: "metric_set_instance_status",
    metric_set_instance_latest_status: "metric_set_instance_latest_status"
  },
  [
    "drafts"
    /* drafts */
  ]: {
    meta_data: "meta_data",
    history: "history",
    list: "list",
    create: "create",
    delete: "delete",
    metric_set_config: "metric_set_config",
    metric_set_config_update: "metric_set_config_update",
    aggregation_levels: "aggregation_levels"
  },
  [
    "draft"
    /* draft */
  ]: {
    history: "history",
    raw_columns: "raw_columns",
    aggregation_levels: "aggregation_levels",
    experiment_config: "experiment_config",
    meta_data: "meta_data",
    scorecard_layouts: "scorecard_layouts",
    computation_templates: "computation_templates",
    computation_template_instances: "computation_template_instances",
    computation_template_instance_metrics: "computation_template_instance_metrics",
    scorecard_layout_paths: "scorecard_layout_paths",
    merge: "merge",
    merge_update: "merge_update",
    validate: "validate",
    validate_result: "validate_result",
    metrics: {
      user_context: {
        metric: "metric",
        query: "query"
      },
      metric_wizard: "metric_wizard",
      create_get: "create_get",
      create_put: "create_put",
      list: "list",
      quick_compile_put: "quick_compile_put",
      quick_compute_put: "quick_compute_put",
      quick_compute_get: "quick_compute_get",
      quick_compute_cancel: "quick_compute_cancel",
      quick_compute_check: "quick_compute_check",
      datasource_get: "datasource_get",
      datasource_details_get: "datasource_details_get"
    },
    metric_health: "metric_health",
    publish: "publish",
    publish_update: "publish_update",
    publish_status: "publish_status",
    published_versions: "published_versions",
    recent_preview_analyses: "recent_preview_analyses",
    experiment: "experiment",
    recent_experiments: "recent_experiments",
    feature_progressions: "feature_progressions",
    recent_features: "recent_features",
    default_experiments: "default_experiments",
    default_features: "default_features",
    experimentation_group_features: "experimentation_group_features",
    experimentation_group_experiments: "experimentation_group_experiments",
    experiment_plan_summaries: "experiment_plan_summaries",
    experiment_steps_validate_result: "experiment_steps_validate_result",
    segments: "segments",
    computation_file_paths: "computation_file_paths",
    columns: "columns"
  }
};
const ACTION_PREFIX = "METRICS_AUTHORING";
const ACTION_PREFIXES = {
  GLOBAL: `${ACTION_PREFIX}/GLOBAL`,
  METRIC_SETS: `${ACTION_PREFIX}/METRIC_SETS`,
  DRAFTS: `${ACTION_PREFIX}/DRAFTS`,
  DRAFT: `${ACTION_PREFIX}/DRAFT`
};
const ACTION_TYPES = {
  GLOBAL: {
    EXPERIMENTATION_GROUPS_WITH_METRICS_WRITE: `${ACTION_PREFIXES.GLOBAL}/EXPERIMENTATION_GROUPS_WITH_METRICS_WRITE`,
    EXPERIMENTATION_GROUPS: `${ACTION_PREFIXES.GLOBAL}/EXPERIMENTATION_GROUPS`,
    CHECK_USER_METRIC_WRITE_ACCESS: `${ACTION_PREFIXES.GLOBAL}/CHECK_USER_METRIC_WRITE_ACCESS`
  },
  METRIC_SETS: {
    LIST: `${ACTION_PREFIXES.METRIC_SETS}/LIST`,
    CREATE: `${ACTION_PREFIXES.METRIC_SETS}/CREATE`,
    RESET_CREATE: `${ACTION_PREFIXES.METRIC_SETS}/RESET_CREATE`,
    CLONE: `${ACTION_PREFIXES.METRIC_SETS}/CLONE`,
    RESET_CLONE: `${ACTION_PREFIXES.METRIC_SETS}/RESET_CLONE`,
    DELETE: `${ACTION_PREFIXES.METRIC_SETS}/DELETE`,
    RESET_DELETE: `${ACTION_PREFIXES.METRIC_SETS}/RESET_DELETE`,
    REMOVE: `${ACTION_PREFIXES.METRIC_SETS}/REMOVE`,
    WORKSPACE_CONFIG: `${ACTION_PREFIXES.METRIC_SETS}/WORKSPACE_CONFIG`,
    METRIC_SET_INSTANCE_CREATE: `${ACTION_PREFIXES.METRIC_SETS}/METRIC_SET_INSTANCE_CREATE`,
    METRIC_SET_INSTANCE_STATUS: `${ACTION_PREFIXES.METRIC_SETS}/METRIC_SET_INSTANCE_STATUS`,
    METRIC_SET_INSTANCE_LATEST_STATUS: `${ACTION_PREFIXES.METRIC_SETS}/METRIC_SET_INSTANCE_LATEST_STATUS`
  },
  DRAFTS: {
    HISTORY: `${ACTION_PREFIXES.DRAFTS}/HISTORY`,
    RESET_HISTORY: `${ACTION_PREFIXES.DRAFTS}/RESET_HISTORY`,
    META_DATA: `${ACTION_PREFIXES.DRAFTS}/META_DATA`,
    RESET_META_DATA: `${ACTION_PREFIXES.DRAFTS}/RESET_META_DATA`,
    LIST: `${ACTION_PREFIXES.DRAFTS}/LIST`,
    CREATE: `${ACTION_PREFIXES.DRAFTS}CREATE`,
    RESET_CREATE: `${ACTION_PREFIXES.DRAFTS}/RESET_CREATE`,
    DELETE: `${ACTION_PREFIXES.DRAFTS}/DELETE`,
    RESET_DELETE: `${ACTION_PREFIXES.DRAFTS}/RESET_DELETE`,
    REMOVE: `${ACTION_PREFIXES.DRAFTS}/REMOVE`,
    METRIC_SET_CONFIG: `${ACTION_PREFIXES.DRAFTS}/METRIC_SET_CONFIG`,
    METRIC_SET_CONFIG_UPDATE: `${ACTION_PREFIXES.DRAFTS}/METRIC_SET_CONFIG_UPDATE`,
    AGGREGATION_LEVELS: `${ACTION_PREFIXES.DRAFTS}/AGGREGATION_LEVELS`
  },
  DRAFT: {
    HISTORY: `${ACTION_PREFIXES.DRAFT}/HISTORY`,
    RESET_HISTORY: `${ACTION_PREFIXES.DRAFT}/RESET_HISTORY`,
    META_DATA: `${ACTION_PREFIXES.DRAFT}/META_DATA`,
    RAW_COLUMNS: `${ACTION_PREFIXES.DRAFT}/RAW_COLUMNS`,
    AGGREGATION_LEVELS: `${ACTION_PREFIXES.DRAFT}/AGGREGATION_LEVELS`,
    EXPERIMENT_CONFIG: `${ACTION_PREFIXES.DRAFT}/EXPERIMENT_CONFIG`,
    SCORECARD_LAYOUTS: `${ACTION_PREFIXES.DRAFT}/SCORECARD_LAYOUTS`,
    COMPUTATION_TEMPLATES: `${ACTION_PREFIXES.DRAFT}/COMPUTATION_TEMPLATES`,
    COMPUTATION_TEMPLATE_INSTANCES: `${ACTION_PREFIXES.DRAFT}/COMPUTATION_TEMPLATE_INSTANCES`,
    COMPUTATION_TEMPLATE_INSTANCE_METRICS: `${ACTION_PREFIXES.DRAFT}/COMPUTATION_TEMPLATE_INSTANCE_METRICS`,
    MERGE: `${ACTION_PREFIXES.DRAFT}/MERGE`,
    RESET_MERGE: `${ACTION_PREFIXES.DRAFT}/RESET_MERGE`,
    UPDATE_MERGE: `${ACTION_PREFIXES.DRAFT}/UPDATE_MERGE`,
    VALIDATE: `${ACTION_PREFIXES.DRAFT}/VALIDATE`,
    VALIDATE_RESULT: `${ACTION_PREFIXES.DRAFT}/VALIDATE_RESULT`,
    RESET_VALIDATE: `${ACTION_PREFIXES.DRAFT}/RESET_VALIDATE`,
    METRICS_HEALTH_STAT_SIG: `${ACTION_PREFIXES.DRAFT}/METRICS_HEALTH_STAT_SIG`,
    PUBLISH: `${ACTION_PREFIXES.DRAFT}/PUBLISH`,
    UPDATE_PUBLISH: `${ACTION_PREFIXES.DRAFT}/UPDATE_PUBLISH`,
    PUBLISH_STATUS: `${ACTION_PREFIXES.DRAFT}/PUBLISH_STATUS`,
    RESET_PUBLISH: `${ACTION_PREFIXES.DRAFT}/RESET_PUBLISH`,
    PUBLISHED_VERSIONS: `${ACTION_PREFIXES.DRAFT}/PUBLISHED_VERSIONS`,
    RECENT_PREVIEW_ANALYSES: `${ACTION_PREFIXES.DRAFT}/RECENT_PREVIEW_ANALYSES`,
    EXPERIMENT: `${ACTION_PREFIXES.DRAFT}/EXPERIMENT`,
    RECENT_EXPERIMENTS: `${ACTION_PREFIXES.DRAFT}/RECENT_EXPERIMENTS`,
    FEATURE_PROGRESSIONS: `${ACTION_PREFIXES.DRAFT}/FEATURE_PROGRESSIONS`,
    RECENT_FEATURES: `${ACTION_PREFIXES.DRAFT}/RECENT_FEATURES`,
    DEFAULT_EXPERIMENTS: `${ACTION_PREFIXES.DRAFT}/DEFAULT_EXPERIMENTS`,
    DEFAULT_FEATURES: `${ACTION_PREFIXES.DRAFT}/DEFAULT_FEATURES`,
    EXPERIMENTATION_GROUP_FEATURES: `${ACTION_PREFIXES.DRAFT}/EXPERIMENTATION_GROUP_FEATURES`,
    EXPERIMENTATION_GROUP_EXPERIMENTS: `${ACTION_PREFIXES.DRAFT}/EXPERIMENTATION_GROUP_EXPERIMENTS`,
    EXPERIMENT_STEP_PLAN_SUMMARIES: `${ACTION_PREFIXES.DRAFT}/EXPERIMENT_STEP_PLAN_SUMMARIES`,
    VALIDATE_EXPERIMENT_STEPS: `${ACTION_PREFIXES.DRAFT}/VALIDATE_EXPERIMENT_STEPS`,
    SEGMENTS_LIST: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_LIST`,
    SEGMENTS_LOAD: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_LOAD`,
    SEGMENTS_CREATE_GET: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_CREATE_GET`,
    SEGMENTS_CREATE_PUT: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_CREATE_PUT`,
    SEGMENTS_ADD: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_CREATE_ADD`,
    SEGMENTS_RESET_CREATE: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_RESET_CREATE`,
    SEGMENTS_DELETE: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_DELETE`,
    SEGMENTS_REMOVE: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_REMOVE`,
    SEGMENTS_RESET_DELETE: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_RESET_DELETE`,
    COMPUTATION_FILE_PATHS: `${ACTION_PREFIXES.DRAFT}/COMPUTATION_FILE_PATHS`,
    COLUMNS: `${ACTION_PREFIXES.DRAFT}/COLUMNS`,
    COLUMN_DETAILS: `${ACTION_PREFIXES.DRAFT}/COLUMN_DETAILS`,
    METRICS_LIST: `${ACTION_PREFIXES.DRAFT}/METRICS`
  }
};
const loadExperimentationGroupsWithMetricWriteEpicReducerArg = {
  actionPrefix: ACTION_TYPES.GLOBAL.EXPERIMENTATION_GROUPS_WITH_METRICS_WRITE,
  reduxKeyNested: () => ["global", REDUCER_KEYS.global.experimentation_groups_with_metric_write],
  loadResource: (inputPayload, state) => VivaceResoures.getExperimentationGroups({
    workspaceId: getWorkspaceIdSelector(state),
    metricWrite: true
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadExperimentationGroupsWithMetricWriteEpicReducer = loadResourcesUtils(
  loadExperimentationGroupsWithMetricWriteEpicReducerArg
);
const loadAllExperimentationGroupsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.GLOBAL.EXPERIMENTATION_GROUPS_WITH_METRICS_WRITE,
  reduxKeyNested: () => ["global", REDUCER_KEYS.global.experimentation_groups],
  loadResource: (inputPayload, state) => VivaceResoures.getExperimentationGroups({
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadAllExperimentationGroupsEpicReducer = loadResourcesUtils(loadAllExperimentationGroupsEpicReducerArg);
const resetCreateMetricSetState = createAction(ACTION_TYPES.METRIC_SETS.RESET_CREATE, (action) => () => action());
const createMetricSetEpicReducerArg = {
  actionPrefix: ACTION_TYPES.METRIC_SETS.CREATE,
  reduxKeyNested: () => ["metric_sets", REDUCER_KEYS.metric_sets.create],
  loadResource: ({ metricSetName, experimentationGroup }, state) => VivaceResoures.createMetricSet({
    metricSetName,
    experimentationGroup,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    var _a, _b;
    const draftName = `${(_a = EnvironmentService.getUser()) == null ? void 0 : _a.alias}_draft`;
    return [
      createMetricSetDraftEpicReducer.actionCreators.load({
        metricSetName: inputPayload.metricSetName,
        draftName,
        setupDraft: true
      }),
      SetSubscribersEpicReducer.actionCreators.load({
        workspaceId: getWorkspaceIdSelector(state),
        entityType: ENTITY_TYPES.METRICSET,
        entityExternalId: inputPayload.metricSetName,
        entityIsNew: true,
        subscriberBaseInfoList: ((_b = inputPayload.subscribers) == null ? void 0 : _b.map(
          (s) => !!s.id ? { id: s.id, type: s.type || "", tenantId: s.tenantId } : { id: s.primaryText, type: "Email" }
        )) || []
      }),
      loadMetricSetsEpicReducer.actionCreators.load({ refresh: true })
    ];
  }
};
const createMetricSetEpicReducer = loadResourcesUtils(createMetricSetEpicReducerArg);
const resetCloneMetricSetState = createAction(ACTION_TYPES.METRIC_SETS.RESET_CLONE, (action) => () => action());
const cloneMetricSetEpicReducerArg = {
  actionPrefix: ACTION_TYPES.METRIC_SETS.CLONE,
  reduxKeyNested: () => ["metric_sets", REDUCER_KEYS.metric_sets.clone],
  loadResource: ({ metricSetName, sourceMetricSetName, experimentationGroup }, state) => VivaceResoures.cloneMetricSet({
    metricSetName,
    sourceMetricSetName,
    experimentationGroup,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: ({ metricSetName, subscribers }, outputPayload, state) => {
    NavigationService.navigateTo(
      MetricsAuthoringRouteUtils.routes.viewDrafts.url({
        metricSetName
      })
    );
    return [
      resetCloneMetricSetState(),
      SetSubscribersEpicReducer.actionCreators.load({
        workspaceId: getWorkspaceIdSelector(state),
        entityType: ENTITY_TYPES.METRICSET,
        entityExternalId: metricSetName,
        entityIsNew: true,
        subscriberBaseInfoList: (subscribers == null ? void 0 : subscribers.map(
          (s) => !!s.id ? { id: s.id, type: s.type || "", tenantId: s.tenantId } : { id: s.primaryText, type: "Email" }
        )) || []
      })
    ];
  }
};
const cloneMetricSetEpicReducer = loadResourcesUtils(cloneMetricSetEpicReducerArg);
const removeMetricSetFromList = createAction(
  ACTION_TYPES.METRIC_SETS.REMOVE,
  (action) => (metricSetName) => action(metricSetName)
);
const resetDeleteMetricSetState = createAction(ACTION_TYPES.METRIC_SETS.RESET_DELETE, (action) => () => action());
const deleteMetricSetEpicReducerArg = {
  actionPrefix: ACTION_TYPES.METRIC_SETS.DELETE,
  reduxKeyNested: () => ["metric_sets", REDUCER_KEYS.metric_sets.delete],
  loadResource: ({ metricSetName }, state) => VivaceResoures.deleteMetricSet({
    metricSetName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload) => [
    removeMetricSetFromList(inputPayload.metricSetName)
  ]
};
const deleteMetricSetEpicReducer = loadResourcesUtils(deleteMetricSetEpicReducerArg);
const loadMetricSetsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.METRIC_SETS.LIST,
  reduxKeyNested: () => ["metric_sets", REDUCER_KEYS.metric_sets.list],
  loadResource: (inputPayload, state) => MetricServiceResource.getMetricSets({
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  dontLoad: (payload, state) => {
    if (payload == null ? void 0 : payload.refresh) {
      return false;
    }
    return requestPendingOrCompleted(state.maui[
      "metric_sets"
      /* metric_sets */
    ].list.status);
  }
};
const loadMetricSetsEpicReducer = loadResourcesUtils(loadMetricSetsEpicReducerArg);
const loadProductionDraftEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFTS.META_DATA,
  reduxKeyNested: () => ["drafts", REDUCER_KEYS.drafts.meta_data],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMetricSetDraftMetadata({
    metricSetName,
    draftName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadProductionMetaDataEpicReducer = loadResourcesUtils(loadProductionDraftEpicReducerArg);
const resetProductionDraftMetaDataState = createAction(ACTION_TYPES.DRAFTS.RESET_META_DATA, (action) => () => action());
const loadProductionDraftHistoryEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFTS.HISTORY,
  reduxKeyNested: () => ["drafts", REDUCER_KEYS.drafts.history],
  loadResource: ({ metricSetName }, state) => VivaceResoures.getMetricSetHistory({
    metricSetName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadProductionHistoryEpicReducer = loadResourcesUtils(loadProductionDraftHistoryEpicReducerArg);
const resetProductionDraftHistoryState = createAction(ACTION_TYPES.DRAFTS.RESET_HISTORY, (action) => () => action());
const loadMetricSetDraftsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFTS.LIST,
  reduxKeyNested: () => ["drafts", REDUCER_KEYS.drafts.list],
  loadResource: ({ metricSetName }, state) => VivaceResoures.getMetricSetDrafts({
    metricSetName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadMetricSetDraftsEpicReducer = loadResourcesUtils(loadMetricSetDraftsEpicReducerArg);
const loadMetricSetDraftMetadataEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.META_DATA,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.meta_data],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMetricSetDraftMetadata({
    metricSetName,
    draftName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadMetricSetDraftMetadataEpicReducer = loadResourcesUtils(loadMetricSetDraftMetadataEpicReducerArg);
const loadMetricSetDraftHistoryEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.HISTORY,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.history],
  loadResource: ({ metricSetName }, state) => VivaceResoures.getMetricSetHistory({
    metricSetName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadMetricSetDraftHistoryEpicReducer = loadResourcesUtils(loadMetricSetDraftHistoryEpicReducerArg);
const resetMetricSetDraftHistoryState = createAction(ACTION_TYPES.DRAFT.RESET_HISTORY, (action) => () => action());
const loadMetricSetDraftRawColumnsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.RAW_COLUMNS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.raw_columns],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMetricSetDraftRawColumns({
    metricSetName,
    draftName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => {
    var _a, _b;
    const namespaceNode = (_b = (_a = resourceResult.Mdl) == null ? void 0 : _a.Namespaces) == null ? void 0 : _b.Namespace;
    const namespaceList = Array.isArray(namespaceNode) ? namespaceNode : namespaceNode ? [namespaceNode] : [];
    const allRawColumns = namespaceList.map((namespace) => {
      const tableNode = namespace.Tables.Table;
      const tablesList = Array.isArray(tableNode) ? tableNode : tableNode ? [tableNode] : [];
      const columnsFromTables = tablesList.map((table) => {
        const columnsList = table.Columns ? table.Columns.i : null;
        if (columnsList && Array.isArray(columnsList)) {
          return (columnsList || []).map((rawColumnApiResponse) => {
            const rawColumn = {
              name: rawColumnApiResponse["@Name"],
              type: rawColumnApiResponse["@Type"],
              isPublic: rawColumnApiResponse["@IsPublic"] === "true",
              namespace: namespace["@Name"]
            };
            return rawColumn;
          });
        } else if (columnsList) {
          return [columnsList];
        } else {
          return [];
        }
      });
      return columnsFromTables;
    });
    const rawColumns = ___default.flatMapDeep(allRawColumns);
    return rawColumns || [];
  }
};
const loadMetricSetDraftRawColumnsEpicReducer = loadResourcesUtils(loadMetricSetDraftRawColumnsEpicReducerArg);
const loadMetricSetDraftAggregationLevelsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.AGGREGATION_LEVELS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.aggregation_levels],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMetricSetDraftAggregationLevels({
    metricSetName,
    draftName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => {
    const namespaceNode = resourceResult.Mdl.Namespaces.Namespace;
    const namespaceList = Array.isArray(namespaceNode) ? namespaceNode : namespaceNode ? [namespaceNode] : [];
    const allAggregationLevels = mapIfDefined(namespaceList, (namespace) => {
      const tables = namespace.Tables.Table;
      if (tables) {
        const tableArray = Array.isArray(tables) ? tables : [tables];
        const currentGroupByColumns = (tableArray || []).map((column) => {
          const sourceTable = typeof column.SourceTable === "object" && "#text" in column.SourceTable ? column.SourceTable["#text"] : column.SourceTable;
          const groupByColumn = column.GroupByColumn && typeof column.GroupByColumn === "object" && "#text" in column.GroupByColumn ? column.GroupByColumn["#text"] : column.GroupByColumn;
          const aggregationLevel = {
            namespace: namespace["@Name"],
            name: column["@Name"],
            sourceTable,
            groupByColumn
          };
          return aggregationLevel;
        });
        return currentGroupByColumns;
      }
    });
    const aggregationLevels = ___default.flatMapDeep(allAggregationLevels);
    return aggregationLevels || [];
  }
};
const loadMetricSetDraftAggregationLevelsEpicReducer = loadResourcesUtils(
  loadMetricSetDraftAggregationLevelsEpicReducerArg
);
const loadMetricSetDraftExperimentationConfigEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.EXPERIMENT_CONFIG,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.experiment_config],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMetricSetDraftExperimentationConfig({
    metricSetName,
    draftName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const loadMetricSetDraftExperimentationConfigEpicReducer = loadResourcesUtils(
  loadMetricSetDraftExperimentationConfigEpicReducerArg
);
const loadScorecardLayoutsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.SCORECARD_LAYOUTS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.scorecard_layouts],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getScorecardLayouts({
    metricSetName,
    draftName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const loadScorecardLayoutsEpicReducer = loadResourcesUtils(loadScorecardLayoutsEpicReducerArg);
const loadComputationTemplatesEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.COMPUTATION_TEMPLATES,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.computation_templates],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getComputationTemplates({
    metricSetName,
    draftName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => {
    return resourceResult.map((item) => {
      var _a, _b;
      if (((_b = (_a = item.i) == null ? void 0 : _a.TemplateParameters) == null ? void 0 : _b.TemplateParameter) && !Array.isArray(item.i.TemplateParameters.TemplateParameter)) {
        item.i.TemplateParameters.TemplateParameter = [item.i.TemplateParameters.TemplateParameter];
      }
      return item;
    });
  }
};
const loadComputationTemplatesEpicReducer = loadResourcesUtils(loadComputationTemplatesEpicReducerArg);
const loadComputationTemplateInstancesEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.COMPUTATION_TEMPLATE_INSTANCES,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.computation_template_instances],
  loadResource: ({ metricSetName, draftName, templateName }, state) => VivaceResoures.getComputationTemplateInstances({
    metricSetName,
    draftName,
    templateName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const loadComputationTemplateInstancesEpicReducer = loadResourcesUtils(loadComputationTemplateInstancesEpicReducerArg);
const loadMetricsForCompuatationTemplateInstancesEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.COMPUTATION_TEMPLATE_INSTANCE_METRICS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.computation_template_instance_metrics],
  loadResource: ({ metricSetName, draftName, templateName }, state) => VivaceResoures.getMetricsForTemplateInstance({
    workspaceId: getWorkspaceIdSelector(state),
    metricSetName,
    draftName,
    templateName
  }),
  onCompleteSuccess: (resourceResult, payload) => {
    if (!resourceResult) {
      return [];
    }
    return resourceResult.filter((metric) => metric.i["@InstanceId"] === payload.instanceId);
  }
};
const loadMetricsForCompuatationTemplateInstancesEpicReducer = loadResourcesUtils(
  loadMetricsForCompuatationTemplateInstancesEpicReducerArg
);
const resetCreateMetricSetDraftState = createAction(ACTION_TYPES.DRAFTS.RESET_CREATE, (action) => () => action());
const createMetricSetDraftEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFTS.CREATE,
  reduxKeyNested: () => ["drafts", REDUCER_KEYS.drafts.create],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.createDraft({
    metricSetName,
    draftName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnFailure({ metricSetName, setupDraft }) {
    if (setupDraft) {
      return [loadMetricSetsEpicReducer.actionCreators.load({})];
    }
    return [];
  },
  afterActionsOnSuccess: ({ metricSetName, draftName, setupDraft }, outputPayload) => {
    if (setupDraft) {
      NavigationService.navigateTo(
        MetricsAuthoringRouteUtils.routes.metricSetup.url({
          metricSetName,
          draftName,
          view: MAUIConfigurationPaths["data-source"]
        })
      );
      return [resetCreateMetricSetState(), resetCreateMetricSetDraftState()];
    } else {
      NavigationService.navigateTo(
        MetricsAuthoringRouteUtils.routes.viewMetricSet.url({
          metricSetName,
          draftName,
          entityName: MAUIDraftEntityPaths.metric
        })
      );
    }
    return [resetCreateMetricSetDraftState()];
  }
};
const createMetricSetDraftEpicReducer = loadResourcesUtils(createMetricSetDraftEpicReducerArg);
const removeDraftFromList = createAction(ACTION_TYPES.DRAFTS.REMOVE, (action) => (draftName) => action(draftName));
const resetDeleteMetricSetDraftState = createAction(ACTION_TYPES.DRAFTS.RESET_DELETE, (action) => () => action());
const deleteMetricSetDraftEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFTS.DELETE,
  reduxKeyNested: () => ["drafts", REDUCER_KEYS.drafts.delete],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.deleteDraft({
    metricSetName,
    draftName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload) => [
    removeDraftFromList(inputPayload.draftName)
  ]
};
const deleteMetricSetDraftEpicReducer = loadResourcesUtils(deleteMetricSetDraftEpicReducerArg);
const mergeMetricSetDraftEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.MERGE,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.merge],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.mergeMetricSetDraft({
    metricSetName,
    workspaceId: getWorkspaceIdSelector(state),
    draftName
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const mergeMetricSetDraftEpicReducer = loadResourcesUtils(mergeMetricSetDraftEpicReducerArg);
const updateMergeStatusMetricSetDraftEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.UPDATE_MERGE,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.merge_update],
  loadResource: ({ metricSetName, draftName, mergeStatus }, state) => VivaceResoures.updateMergeStatus({
    metricSetName,
    workspaceId: getWorkspaceIdSelector(state),
    draftName,
    mergeStatus
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const updateMergeStatusMetricSetDraftEpicReducer = loadResourcesUtils(updateMergeStatusMetricSetDraftEpicReducerArg);
const resetMergeMetricSetDraftStateActionName = ACTION_TYPES.DRAFT.RESET_MERGE;
const resetMergeMetricSetDraftState = createAction(resetMergeMetricSetDraftStateActionName, (action) => () => action());
const validateMetricSetDraftEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.VALIDATE,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.validate],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.validateMetricSetDraft({
    metricSetName,
    workspaceId: getWorkspaceIdSelector(state),
    draftName
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  onLoaded: (resourceResult, payload, state) => ({
    isSuccessful: !!resourceResult && resourceResult.isSuccessful(),
    data: !!resourceResult && resourceResult.isSuccessful() ? resourceResult.getRawData() : null
  })
};
const validateMetricSetDraftEpicReducer = loadResourcesUtils(validateMetricSetDraftEpicReducerArg);
const resetValidateMetricSetDraftStateActionName = ACTION_TYPES.DRAFT.RESET_VALIDATE;
const resetValidateMetricSetDraftState = createAction(
  resetValidateMetricSetDraftStateActionName,
  (action) => () => action()
);
const getValidateResultEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.VALIDATE_RESULT,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.validate_result],
  loadResource: ({ metricSetName, draftName, validationRequestId }, state) => VivaceResoures.getValidationResult({
    metricSetName,
    workspaceId: getWorkspaceIdSelector(state),
    draftName,
    requestId: validationRequestId
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const getValidateResultEpicReducer = loadResourcesUtils(getValidateResultEpicReducerArg);
const publishMetricSetDraftEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.PUBLISH,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.publish],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.publishMetricSetDraft({
    metricSetName,
    workspaceId: getWorkspaceIdSelector(state),
    draftName
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  onLoaded: (resourceResult, payload, state) => ({
    isSuccessful: !!resourceResult && resourceResult.isSuccessful(),
    data: !!resourceResult && resourceResult.isSuccessful() ? resourceResult.getRawData() : null
  })
};
const publishMetricSetDraftEpicReducer = loadResourcesUtils(publishMetricSetDraftEpicReducerArg);
const updatePublishStatusMetricSetDraftEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.UPDATE_PUBLISH,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.publish_update],
  loadResource: ({ metricSetName, draftName, publishStatus }, state) => VivaceResoures.updatePublishStatus({
    metricSetName,
    workspaceId: getWorkspaceIdSelector(state),
    draftName,
    publishStatus
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const updatePublishStatusMetricSetDraftEpicReducer = loadResourcesUtils(updatePublishStatusMetricSetDraftEpicReducerArg);
const resetPublishMetricSetDraftStateActionName = ACTION_TYPES.DRAFT.RESET_PUBLISH;
const resetPublishMetricSetDraftState = createAction(
  resetPublishMetricSetDraftStateActionName,
  (action) => () => action()
);
const loadPublishStatusEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.PUBLISH_STATUS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.publish_status],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getPublishStatus({
    workspaceId: getWorkspaceIdSelector(state),
    metricSetName,
    draftName
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadPublishStatusEpicReducer = loadResourcesUtils(loadPublishStatusEpicReducerArg);
const loadPublishedVersionsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.PUBLISHED_VERSIONS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.published_versions],
  loadResource: ({ metricSetName, isDraft }, state) => VivaceResoures.getPublishedVersions({
    workspaceId: getWorkspaceIdSelector(state),
    metricSetName,
    isDraft
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadPublishedVersionsEpicReducer = loadResourcesUtils(loadPublishedVersionsEpicReducerArg);
const loadRecentPreviewAnalysisEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.RECENT_PREVIEW_ANALYSES,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.recent_preview_analyses],
  loadResource: ({ metricSetName }, state) => AnalysisResource.getPreviewAnalyses(getWorkspaceIdSelector(state), metricSetName),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => inputPayload.getExperimentSteps ? [
    loadRecentExperimentsEpicReducer.actionCreators.load({
      getFeatures: true,
      experimentIds: ___default.uniq(
        ___default.filter(
          outputPayload.value,
          (analysis) => !!analysis.experimentMetadata.experimentId && analysis.experimentMetadata.workspaceId === getWorkspaceIdSelector(state)
        ).map((analysis) => analysis.experimentMetadata.experimentId)
      )
    })
  ] : []
};
const loadRecentPreviewAnalysisEpicReducer = loadResourcesUtils(loadRecentPreviewAnalysisEpicReducerArg);
const loadExperimentEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.EXPERIMENT,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.experiment],
  loadResource: ({ experimentId }, state) => experimentUnifiedResource.getExperimentRestResult(getWorkspaceIdSelector(state), experimentId),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadExperimentEpicReducer = loadResourcesUtils(loadExperimentEpicReducerArg);
const loadRecentExperimentsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.RECENT_EXPERIMENTS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.recent_experiments],
  loadResource: (_0, _1) => __async(void 0, [_0, _1], function* ({ experimentIds }, state) {
    const experiments = yield Promise.all(
      ___default.map(
        experimentIds,
        (experimentId) => experimentUnifiedResource.getExperiment(getWorkspaceIdSelector(state), experimentId)
      )
    );
    return RestResult.fromResult(experiments);
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => inputPayload.getFeatures ? [
    loadRecentFeaturesEpicReducer.actionCreators.load({
      featureIds: ___default.uniq(
        ___default.filter(
          outputPayload,
          (experiment) => experiment.featureId !== "00000000-0000-0000-0000-000000000000" && experiment.featureId !== experiment.id
        ).map((experiment) => experiment.featureId)
      )
    })
  ] : []
};
const loadRecentExperimentsEpicReducer = loadResourcesUtils(loadRecentExperimentsEpicReducerArg);
const loadFeatureProgressionsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.FEATURE_PROGRESSIONS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.feature_progressions],
  loadResource: ({ featureId }, state) => FeatureResources.loadProgressionsRestResult(featureId, false, true),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadFeatureProgressionsEpicReducer = loadResourcesUtils(loadFeatureProgressionsEpicReducerArg);
const loadRecentFeaturesEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.RECENT_FEATURES,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.recent_features],
  loadResource: (_0, _1) => __async(void 0, [_0, _1], function* ({ featureIds }, state) {
    const results = yield Promise.all(
      ___default.map(featureIds, (featureId) => featureUnifiedResource.getFeature(getWorkspaceIdSelector(state), featureId))
    );
    const features = ___default.map(results, (result) => result.getSuccessData());
    return RestResult.fromResult(features);
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadRecentFeaturesEpicReducer = loadResourcesUtils(loadRecentFeaturesEpicReducerArg);
const loadDefaultExperimentsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.DEFAULT_EXPERIMENTS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.default_experiments],
  loadResource: (_0, _1) => __async(void 0, [_0, _1], function* ({ experimentIds }, state) {
    const experiments = yield Promise.all(
      ___default.map(
        experimentIds,
        (experimentId) => experimentUnifiedResource.getExperiment(getWorkspaceIdSelector(state), experimentId)
      )
    );
    return RestResult.fromResult(experiments);
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => [
    loadDefaultFeaturesEpicReducer.actionCreators.load({
      featureIds: ___default.uniq(
        ___default.filter(
          outputPayload,
          (experiment) => experiment.featureId !== "00000000-0000-0000-0000-000000000000" && experiment.featureId !== experiment.id
        ).map((experiment) => experiment.featureId)
      )
    })
  ]
};
const loadDefaultExperimentsEpicReducer = loadResourcesUtils(loadDefaultExperimentsEpicReducerArg);
const loadDefaultFeaturesEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.DEFAULT_FEATURES,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.default_features],
  loadResource: (_0, _1) => __async(void 0, [_0, _1], function* ({ featureIds }, state) {
    const results = yield Promise.all(
      ___default.map(featureIds, (featureId) => featureUnifiedResource.getFeature(getWorkspaceIdSelector(state), featureId))
    );
    const features = ___default.map(results, (result) => result.getSuccessData());
    return RestResult.fromResult(features);
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadDefaultFeaturesEpicReducer = loadResourcesUtils(loadDefaultFeaturesEpicReducerArg);
const loadFeaturesForExperimentationGroupEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.EXPERIMENTATION_GROUP_FEATURES,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.experimentation_group_features],
  loadResource: (payload) => featureUnifiedResource.getFeatures(payload.workspaceId, {
    experimentationGroup: payload.experimentationGroup,
    isArchived: false,
    top: EnvironmentService.previewScorecardSearchCountUnified(),
    skip: 0,
    onlyLoadFeatureData: true,
    collapseRolloutTargetsIntoRoot: true
  }),
  onCompleteSuccess: (result) => result ? result.value : []
};
const loadFeaturesForExperimentationGroupEpicReducer = loadResourcesUtils(
  loadFeaturesForExperimentationGroupEpicReducerArg
);
const loadExperimentsForExperimentationGroupEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.EXPERIMENTATION_GROUP_EXPERIMENTS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.experimentation_group_experiments],
  loadResource: (payload) => {
    const address = `?workspaceId=${payload.workspaceId}&managementGroup=${payload.experimentationGroup}&CollapseRolloutTargetsIntoRoot=true&top=${EnvironmentService.previewScorecardSearchCountLegacy()}`;
    return legacyExperimentResource.getAllExperiments(address);
  },
  onCompleteSuccess: (result) => result.Results
};
const loadExperimentsForExperimentationGroupEpicReducer = loadResourcesUtils(
  loadExperimentsForExperimentationGroupEpicReducerArg
);
const loadExperimentStepPlanSummariesEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.EXPERIMENT_STEP_PLAN_SUMMARIES,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.experiment_plan_summaries],
  loadResource: (_0, _1) => __async(void 0, [_0, _1], function* ({ stepIds }, state) {
    const results = yield Promise.all(
      stepIds.map((stepId) => __async(void 0, null, function* () {
        return { [stepId]: yield AnalysisResources.getExperimentStepPlanSummary(stepId) };
      }))
    );
    const experimentStepPlans = results.filter((result) => Object.values(result)[0].isSuccessful()).map((successfulResult) => {
      return { [Object.keys(successfulResult)[0]]: Object.values(successfulResult)[0].getSuccessData() };
    });
    return RestResult.fromResult(experimentStepPlans);
  }),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => [
    loadDefaultExperimentsEpicReducer.actionCreators.load({
      experimentIds: ___default.uniq(
        outputPayload.filter((experimentPlan) => inCurrentWorkspaceFilter(experimentPlan, getWorkspaceIdSelector(state))).map((experimentPlan) => Object.values(experimentPlan)[0].Id)
      )
    })
  ]
};
const loadExperimentStepPlanSummariesEpicReducer = loadResourcesUtils(loadExperimentStepPlanSummariesEpicReducerArg);
const validateExperimentStepsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.VALIDATE_EXPERIMENT_STEPS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.experiment_steps_validate_result],
  loadResource: (payload) => __async(void 0, null, function* () {
    const experimentStepPlanSummaries = yield Promise.all(
      ___default.map(payload.metricSetConfig.defaultExperimentStepsForPreviewScorecard, (stepId) => __async(void 0, null, function* () {
        return { [stepId]: yield AnalysisResources.getExperimentStepPlanSummary(stepId) };
      }))
    );
    const validationResults = ___default.map(experimentStepPlanSummaries, (experimentStepPlanSummary) => {
      const stepId = Object.keys(experimentStepPlanSummary)[0];
      const result = Object.values(experimentStepPlanSummary)[0];
      if (result.statusCode >= 400) {
        return { [stepId]: false };
      } else
        return { [stepId]: true };
    });
    return RestResult.fromResult(validationResults);
  }),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess(inputPayload, outputPayload, state) {
    let inValidSteps = [];
    outputPayload.map((validationResult) => {
      if (Object.values(validationResult)[0] === false) {
        inValidSteps.push(Object.keys(validationResult)[0]);
      }
    });
    if (inValidSteps.length > 0) {
      return [];
    }
    return [
      updateMetricSetConfigEpicReducer.actionCreators.load({
        metricSetConfig: inputPayload.metricSetConfig
      })
    ];
  }
};
const validateExperimentStepsEpicReducer = loadResourcesUtils(validateExperimentStepsEpicReducerArg);
const checkUserMetriCWriteAccessEpicReducerArg = {
  actionPrefix: ACTION_TYPES.GLOBAL.CHECK_USER_METRIC_WRITE_ACCESS,
  reduxKeyNested: ({ workspaceId, metricSetName, draftName }) => {
    const key = getDraftWorkspaceDictionaryKey({ workspaceId, metricSetName, draftName });
    return ["global", REDUCER_KEYS.global.user_metric_write_access, key];
  },
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getUserMetricWriteAccess({
    metricSetName,
    workspaceId: getWorkspaceIdSelector(state),
    draftName
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  dontLoad: ({ workspaceId, metricSetName, draftName }, state) => {
    var _a;
    const key = getDraftWorkspaceDictionaryKey({ workspaceId, metricSetName, draftName });
    return ((_a = state.maui.global.user_metric_write_access[key]) == null ? void 0 : _a.status) === AsyncRequestStatus.Completed;
  }
};
const checkUserMetricWriteAccessEpicReducer = loadResourcesUtils(checkUserMetriCWriteAccessEpicReducerArg);
const loadMetricSetConfigEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFTS.METRIC_SET_CONFIG,
  reduxKeyNested: () => {
    return ["drafts", REDUCER_KEYS.drafts.metric_set_config];
  },
  loadResource: ({ metricSetName }, state) => VivaceResoures.getMetricSetConfig({
    workspaceId: getWorkspaceIdSelector(state),
    metricSetName
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadMetricSetConfigEpicReducer = loadResourcesUtils(loadMetricSetConfigEpicReducerArg);
const updateMetricSetConfigEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFTS.METRIC_SET_CONFIG_UPDATE,
  reduxKeyNested: () => {
    return ["drafts", REDUCER_KEYS.drafts.metric_set_config_update];
  },
  loadResource: ({ metricSetConfig }, state) => {
    metricSetConfig.workspace = getWorkspaceIdSelector(state);
    return VivaceResoures.putMetricSetConfig({
      workspaceId: metricSetConfig.workspace,
      request: metricSetConfig
    });
  },
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    return [
      loadMetricSetConfigEpicReducer.actionCreators.loaded(
        {
          metricSetName: inputPayload.metricSetConfig.metricSet
        },
        getCompletedAsyncWrapperObj(inputPayload.metricSetConfig)
      )
    ];
  }
};
const updateMetricSetConfigEpicReducer = loadResourcesUtils(updateMetricSetConfigEpicReducerArg);
const createMetricSetInstanceEpicReducerArg = {
  actionPrefix: ACTION_TYPES.METRIC_SETS.METRIC_SET_INSTANCE_CREATE,
  reduxKeyNested: () => ["metric_sets", REDUCER_KEYS.metric_sets.metric_set_instance_create],
  loadResource: (request, state) => {
    return VivaceResoures.postMetricSetInstance({
      workspaceId: getWorkspaceIdSelector(state),
      request
    });
  },
  onCompleteSuccess: (resourceResult) => resourceResult
};
const createMetricSetInstanceEpicReducer = loadResourcesUtils(createMetricSetInstanceEpicReducerArg);
const loadMetricSetInstanceStatusEpicReducerArg = {
  actionPrefix: ACTION_TYPES.METRIC_SETS.METRIC_SET_INSTANCE_STATUS,
  reduxKeyNested: () => ["metric_sets", REDUCER_KEYS.metric_sets.metric_set_instance_status],
  loadResource: (payload, state) => {
    return VivaceResoures.getMetricSetInstanceCreateStatus({
      workspaceId: getWorkspaceIdSelector(state),
      metricSetName: payload.metricSetName,
      operationId: payload.operationId
    });
  },
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadMetricSetInstanceStatusEpicReducer = loadResourcesUtils(loadMetricSetInstanceStatusEpicReducerArg);
const loadMetricSetInstanceLatestStatusEpicReducerArg = {
  actionPrefix: ACTION_TYPES.METRIC_SETS.METRIC_SET_INSTANCE_LATEST_STATUS,
  reduxKeyNested: () => ["metric_sets", REDUCER_KEYS.metric_sets.metric_set_instance_latest_status],
  loadResource: (payload, state) => {
    return VivaceResoures.getMetricSetInstanceSyncStatus({
      workspaceId: getWorkspaceIdSelector(state),
      metricSetName: payload.metricSetName
    });
  },
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadMetricSetInstanceLatestStatusEpicReducer = loadResourcesUtils(loadMetricSetInstanceLatestStatusEpicReducerArg);
const loadWorkspaceConfigEpicReducerArg = {
  actionPrefix: ACTION_TYPES.METRIC_SETS.WORKSPACE_CONFIG,
  reduxKeyNested: () => {
    return ["metric_sets", REDUCER_KEYS.metric_sets.workspace_config];
  },
  loadResource: (_2, state) => VivaceResoures.getWorkspaceConfig({
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadWorkspaceConfigEpicReducer = loadResourcesUtils(loadWorkspaceConfigEpicReducerArg);
const loadMetricSetMainAggregationLevelsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFTS.AGGREGATION_LEVELS,
  reduxKeyNested: () => ["drafts", REDUCER_KEYS.drafts.aggregation_levels],
  loadResource: ({ metricSetName }, state) => VivaceResoures.getMetricSetDraftAggregationLevels({
    metricSetName,
    draftName: PRODUCTION_BRANCH_ID,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => {
    if (!resourceResult || !resourceResult.Mdl) {
      return [];
    }
    const namespaceNode = resourceResult.Mdl.Namespaces.Namespace;
    const namespaceList = Array.isArray(namespaceNode) ? namespaceNode : namespaceNode ? [namespaceNode] : [];
    const allAggregationLevels = mapIfDefined(namespaceList, (namespace) => {
      const tables = namespace.Tables.Table;
      if (tables) {
        const tableArray = Array.isArray(tables) ? tables : [tables];
        const currentGroupByColumns = (tableArray || []).map((column) => {
          const sourceTable = typeof column.SourceTable === "object" && "#text" in column.SourceTable ? column.SourceTable["#text"] : column.SourceTable;
          const groupByColumn = column.GroupByColumn && typeof column.GroupByColumn === "object" && "#text" in column.GroupByColumn ? column.GroupByColumn["#text"] : column.GroupByColumn;
          const aggregationLevel = {
            namespace: namespace["@Name"],
            name: column["@Name"],
            sourceTable,
            groupByColumn
          };
          return aggregationLevel;
        });
        return currentGroupByColumns;
      }
    });
    const aggregationLevels = ___default.flatMapDeep(allAggregationLevels);
    return aggregationLevels || [];
  },
  onLoaded: (response) => {
    if (!!response && response.statusCode === 404) {
      return { data: {}, isSuccessful: true };
    }
    return void 0;
  }
};
const loadMetricSetMainAggregationLevelsEpicReducer = loadResourcesUtils(loadMetricSetMainAggregationLevelsEpicReducerArg);
const loadMetricHealthResultsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.METRICS_HEALTH_STAT_SIG,
  reduxKeyNested: () => [
    "draft",
    REDUCER_KEYS.draft.metric_health,
    "stat_sig_check"
    /* stat_sig_check */
  ],
  loadResource: (payload, state) => VivaceResoures.getHealthCheck(payload),
  onCompleteSuccess: (result) => result
};
const loadMetricHealthResultsEpicReducer = loadResourcesUtils(loadMetricHealthResultsEpicReducerArg);
const loadComputationFilePathsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.COMPUTATION_FILE_PATHS,
  reduxKeyNested: () => ["draft", REDUCER_KEYS.draft.computation_file_paths],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMDLComputationFiles({
    metricSetName,
    draftName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (result) => result
};
const loadComputationFilePathsEpicReducer = loadResourcesUtils(loadComputationFilePathsEpicReducerArg);
const loadColumnsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.COLUMNS,
  reduxKeyNested: () => [
    "draft",
    REDUCER_KEYS.draft.columns,
    "list"
    /* list */
  ],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getAllComputationsByType({
    metricSetName,
    draftName,
    computationType: ComputationTypes.column,
    offset: 0,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (result) => result.map((r) => r.i)
};
const loadColumnsEpicReducer = loadResourcesUtils(loadColumnsEpicReducerArg);
const loadColumnDetailsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.COLUMN_DETAILS,
  reduxKeyNested: () => [
    "draft",
    REDUCER_KEYS.draft.columns,
    "load"
    /* load */
  ],
  loadResource: ({ metricSetName, draftName, columnName }, state) => VivaceResoures.getAllComputationsByType({
    workspaceId: getWorkspaceIdSelector(state),
    metricSetName,
    draftName,
    computationType: ComputationTypes.column,
    prefix: columnName,
    offset: 0
  }),
  onCompleteSuccess: (resourceResult) => {
    return resourceResult.length > 0 ? resourceResult[0] : null;
  }
};
const loadColumnDetailsEpicReducer = loadResourcesUtils(loadColumnDetailsEpicReducerArg);
const loadMetricsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.METRICS_LIST,
  reduxKeyNested: () => ["draft", "metrics", REDUCER_KEYS.draft.metrics.list],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getAllComputationsByType({
    metricSetName,
    draftName,
    computationType: ComputationTypes.metric,
    offset: 0,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (result) => result.map((r) => r.i)
};
const loadMetricsEpicReducer = loadResourcesUtils(loadMetricsEpicReducerArg);
const loadSegmentsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.SEGMENTS_LIST,
  reduxKeyNested: () => [
    "draft",
    REDUCER_KEYS.draft.segments,
    "list"
    /* list */
  ],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getAllComputationsByType({
    metricSetName,
    draftName,
    computationType: ComputationTypes.segment,
    offset: 0,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadSegmentsEpicReducer = loadResourcesUtils(loadSegmentsEpicReducerArg);
const loadSelectedSegmentEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.SEGMENTS_LOAD,
  reduxKeyNested: () => [
    "draft",
    REDUCER_KEYS.draft.segments,
    "load"
    /* load */
  ],
  loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getAllComputationsByType({
    metricSetName,
    draftName,
    computationType: ComputationTypes.segment,
    offset: 0,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult, inputPayload) => {
    const segment = inputPayload.segment;
    if (!!segment) {
      return resourceResult.find(
        (c) => c.filePath === segment.filePath && c.i["@Name"] === segment.name && c.i["@Level"] === segment.level
      );
    } else {
      return resourceResult.find((c) => c.i["@Name"] === inputPayload.segmentName);
    }
  }
};
const loadSelectedSegmentEpicReducer = loadResourcesUtils(loadSelectedSegmentEpicReducerArg);
const removeSegmentsFromList = createAction(
  ACTION_TYPES.DRAFT.SEGMENTS_REMOVE,
  (action) => (segmentsToDelete) => action(segmentsToDelete)
);
const resetDeleteSegmentState = createAction(ACTION_TYPES.DRAFT.SEGMENTS_RESET_DELETE, (action) => () => action());
const deleteSegmentEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.SEGMENTS_DELETE,
  customError: (inputPayload, response) => {
    const successfullyDeleted = response.getRawData();
    const failedSegments = inputPayload.segmentsToDelete.filter((s) => !successfullyDeleted.includes(s));
    return {
      displayError: `Failed to delete segments: ${failedSegments.map((s) => "'" + s.name + "'")}. Error: ${response.error} `,
      rawError: failedSegments
    };
  },
  reduxKeyNested: () => [
    "draft",
    REDUCER_KEYS.draft.segments,
    "delete"
    /* delete */
  ],
  loadResource: ({ metricSetName, draftName, segmentsToDelete }, state) => {
    const successfullyDeleted = [];
    const filePathToSegments = {};
    for (var segment of segmentsToDelete) {
      const list = segment.filePath in filePathToSegments ? filePathToSegments[segment.filePath] : [];
      list.push(segment);
      filePathToSegments[segment.filePath] = list;
    }
    return Promise.all(
      Object.entries(filePathToSegments).map(
        ([k, v]) => VivaceResoures.deleteSegments({
          metricSetName,
          draftName,
          workspaceId: getWorkspaceIdSelector(state),
          segmentsToDelete: v,
          computationFileName: k
        }).then((value) => {
          successfullyDeleted.push(...v);
          return value;
        })
      )
    ).then(
      (value) => RestResult.fromResult(successfullyDeleted, successfullyDeleted.length === segmentsToDelete.length),
      (value) => RestResult.fromResult(successfullyDeleted, false)
    );
  },
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload) => [removeSegmentsFromList(inputPayload.segmentsToDelete)],
  afterActionsOnFailure: (inputPayload, outputPayload) => [
    removeSegmentsFromList(
      inputPayload.segmentsToDelete.filter((s) => {
        var _a;
        const failedSegments = ((_a = outputPayload.errorContext) == null ? void 0 : _a.rawError) || inputPayload.segmentsToDelete;
        return !failedSegments.includes(s);
      })
    )
  ]
};
const deleteSegmentEpicReducer = loadResourcesUtils(deleteSegmentEpicReducerArg);
const resetCreateSegmentState = createAction(ACTION_TYPES.DRAFT.SEGMENTS_RESET_CREATE, (action) => () => action());
const addSegmentToList = createAction(
  ACTION_TYPES.DRAFT.SEGMENTS_ADD,
  (action) => (segmentToAdd) => action(segmentToAdd)
);
const putComputationsEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.SEGMENTS_CREATE_PUT,
  reduxKeyNested: () => [
    "draft",
    REDUCER_KEYS.draft.segments,
    "create_put"
    /* create_put */
  ],
  loadResource: ({ metricSetName, draftName, computationFileName, mdlComputations }, state) => VivaceResoures.putMDLComputationFile({
    metricSetName,
    draftName,
    computationFileName,
    workspaceId: getWorkspaceIdSelector(state),
    request: mdlComputations
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload) => {
    Logger.trackEvent({
      name: NewSegmentUITelemetryEventNames.SaveColumnSuccess,
      measurements: {},
      properties: {
        message: `Saved ${inputPayload.isColumn ? "Column" : "Segment"} ${inputPayload.segment["@Name"]} in computationFile ${inputPayload.computationFileName}`
      }
    });
    NavigationService.navigateTo(
      MetricsAuthoringRouteUtils.routes.viewMetricSet.url({
        metricSetName: inputPayload.metricSetName,
        draftName: inputPayload.draftName,
        entityName: inputPayload.isColumn ? MAUIDraftEntityPaths["column"] : MAUIDraftEntityPaths["segment"]
      })
    );
    const actions = [resetCreateSegmentState()];
    if (!inputPayload.segmentEdit && !inputPayload.isColumn) {
      actions.push(addSegmentToList({ i: inputPayload.segment, filePath: inputPayload.computationFileName }));
    }
    return actions;
  }
};
const putComputationsEpicReducer = loadResourcesUtils(putComputationsEpicReducerArg);
const createSegmentEpicReducerArg = {
  actionPrefix: ACTION_TYPES.DRAFT.SEGMENTS_CREATE_GET,
  reduxKeyNested: () => [
    "draft",
    REDUCER_KEYS.draft.segments,
    "create_get"
    /* create_get */
  ],
  loadResource: ({ metricSetName, draftName, computationFileName }, state) => VivaceResoures.getMDLComputationFile({
    metricSetName,
    draftName,
    computationFileName,
    workspaceId: getWorkspaceIdSelector(state)
  }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, computationsFile) => {
    var _a;
    const newComputationsFile = addOrUpdateMDLComputationFile(
      computationsFile,
      inputPayload.segment,
      (_a = inputPayload.segmentEdit) == null ? void 0 : _a.i,
      inputPayload.isColumn
    );
    return [putComputationsEpicReducer.actionCreators.load(__spreadProps(__spreadValues({}, inputPayload), { mdlComputations: newComputationsFile }))];
  }
};
const createSegmentEpicReducer = loadResourcesUtils(createSegmentEpicReducerArg);
const vivaceEpics = combineEpics(
  loadExperimentationGroupsWithMetricWriteEpicReducer.epic,
  loadAllExperimentationGroupsEpicReducer.epic,
  createMetricSetEpicReducer.epic,
  createMetricSetInstanceEpicReducer.epic,
  cloneMetricSetEpicReducer.epic,
  deleteMetricSetEpicReducer.epic,
  loadMetricSetsEpicReducer.epic,
  loadMetricSetDraftsEpicReducer.epic,
  loadMetricSetDraftRawColumnsEpicReducer.epic,
  loadMetricSetDraftAggregationLevelsEpicReducer.epic,
  loadMetricSetDraftExperimentationConfigEpicReducer.epic,
  loadMetricSetDraftMetadataEpicReducer.epic,
  loadMetricSetDraftHistoryEpicReducer.epic,
  loadProductionMetaDataEpicReducer.epic,
  loadScorecardLayoutsEpicReducer.epic,
  loadComputationTemplatesEpicReducer.epic,
  loadComputationTemplateInstancesEpicReducer.epic,
  loadMetricsForCompuatationTemplateInstancesEpicReducer.epic,
  loadProductionHistoryEpicReducer.epic,
  createMetricSetDraftEpicReducer.epic,
  deleteMetricSetDraftEpicReducer.epic,
  mergeMetricSetDraftEpicReducer.epic,
  validateMetricSetDraftEpicReducer.epic,
  getValidateResultEpicReducer.epic,
  loadMetricSetInstanceStatusEpicReducer.epic,
  publishMetricSetDraftEpicReducer.epic,
  loadPublishStatusEpicReducer.epic,
  loadPublishedVersionsEpicReducer.epic,
  loadRecentPreviewAnalysisEpicReducer.epic,
  loadExperimentEpicReducer.epic,
  loadRecentExperimentsEpicReducer.epic,
  loadFeatureProgressionsEpicReducer.epic,
  loadRecentFeaturesEpicReducer.epic,
  loadDefaultExperimentsEpicReducer.epic,
  loadDefaultFeaturesEpicReducer.epic,
  loadFeaturesForExperimentationGroupEpicReducer.epic,
  loadExperimentsForExperimentationGroupEpicReducer.epic,
  checkUserMetricWriteAccessEpicReducer.epic,
  draftMetricsQueryStringEpics,
  loadMetricHealthResultsEpicReducer.epic,
  loadSubscribersEpicReducer.epic,
  loadWorkspaceConfigEpicReducer.epic,
  loadMetricSetConfigEpicReducer.epic,
  loadMetricSetMainAggregationLevelsEpicReducer.epic,
  SetSubscribersEpicReducer.epic,
  loadSegmentsEpicReducer.epic,
  deleteSegmentEpicReducer.epic,
  loadComputationFilePathsEpicReducer.epic,
  loadColumnsEpicReducer.epic,
  loadColumnDetailsEpicReducer.epic,
  loadMetricsEpicReducer.epic,
  createSegmentEpicReducer.epic,
  putComputationsEpicReducer.epic,
  loadSelectedSegmentEpicReducer.epic,
  updateMetricSetConfigEpicReducer.epic,
  loadExperimentStepPlanSummariesEpicReducer.epic,
  validateExperimentStepsEpicReducer.epic,
  updateMergeStatusMetricSetDraftEpicReducer.epic,
  updatePublishStatusMetricSetDraftEpicReducer.epic,
  loadMetricSetInstanceLatestStatusEpicReducer.epic
);
export {
  loadFeaturesForExperimentationGroupEpicReducer as $,
  loadMetricSetsEpicReducer as A,
  loadMetricSetInstanceStatusEpicReducer as B,
  loadMetricSetDraftHistoryEpicReducer as C,
  loadMetricSetDraftExperimentationConfigEpicReducer as D,
  loadMetricSetDraftMetadataEpicReducer as E,
  loadScorecardLayoutsEpicReducer as F,
  createMetricSetDraftEpicReducer as G,
  mergeMetricSetDraftEpicReducer as H,
  validateMetricSetDraftEpicReducer as I,
  getValidateResultEpicReducer as J,
  publishMetricSetDraftEpicReducer as K,
  loadPublishStatusEpicReducer as L,
  loadMetricHealthResultsEpicReducer as M,
  loadMetricSetConfigEpicReducer as N,
  updateMetricSetConfigEpicReducer as O,
  loadMetricSetMainAggregationLevelsEpicReducer as P,
  loadWorkspaceConfigEpicReducer as Q,
  deleteSegmentEpicReducer as R,
  loadSegmentsEpicReducer as S,
  loadPublishedVersionsEpicReducer as T,
  loadRecentPreviewAnalysisEpicReducer as U,
  loadExperimentEpicReducer as V,
  loadRecentExperimentsEpicReducer as W,
  loadFeatureProgressionsEpicReducer as X,
  loadRecentFeaturesEpicReducer as Y,
  loadDefaultExperimentsEpicReducer as Z,
  loadDefaultFeaturesEpicReducer as _,
  resetProductionDraftHistoryState as a,
  validateDefaultExperiments as a$,
  loadExperimentsForExperimentationGroupEpicReducer as a0,
  putComputationsEpicReducer as a1,
  loadSelectedSegmentEpicReducer as a2,
  loadExperimentStepPlanSummariesEpicReducer as a3,
  validateExperimentStepsEpicReducer as a4,
  updateMergeStatusMetricSetDraftEpicReducer as a5,
  updatePublishStatusMetricSetDraftEpicReducer as a6,
  loadMetricSetInstanceLatestStatusEpicReducer as a7,
  METRICS_REDUCER_KEYS as a8,
  ACTION_TYPES as a9,
  getDraftFromAnalysisMetricSetVersion as aA,
  RecentPreviewAnalysisListLabels as aB,
  getStartTimeDisplayText as aC,
  ExperimentStepOption as aD,
  PublishedVersionFilterOptions as aE,
  RecentAnalysisFilterOptions as aF,
  CREATE_PREVIEW_SCORECARD as aG,
  CreateAnalysisButton as aH,
  ExperimentStepLabelInfoIcon as aI,
  RecentExperimentStepLabelInfoIcon as aJ,
  DefaultExperimentStepLabelInfoIcon as aK,
  PreviewFromExperimentStepLinkProps as aL,
  LegacyExperimentSearchInfoIconProps as aM,
  UnifiedFeatureSearchInfoIconProps as aN,
  selectStepComboBoxStyle as aO,
  RecentExperimentStepsSelection as aP,
  UnifiedSearchExperiments as aQ,
  LegacySearchExperiments as aR,
  DefaultExperimentStepsSelection as aS,
  isFeatureRollout as aT,
  getRecentExperimentStepsOptions as aU,
  getExperimentStepsFromProgressions as aV,
  getExperimentStepsFromExperiment as aW,
  getSearchURL as aX,
  getPreviewAnalysisStudyCreateURL as aY,
  viewExperiment as aZ,
  validateRecentExperiments as a_,
  ROOT_REDUCER_KEYS as aa,
  DRAFT_REDUCER_KEYS as ab,
  REDUCER_KEYS as ac,
  resetCreateMetricSetDraftState as ad,
  resetMetricSetDraftHistoryState as ae,
  resetMergeMetricSetDraftState as af,
  resetValidateMetricSetDraftState as ag,
  resetPublishMetricSetDraftState as ah,
  CreatePreviewScorecardForm as ai,
  resetDeleteMetricSetState as aj,
  resetCreateMetricSetState as ak,
  resetCloneMetricSetState as al,
  resetDeleteSegmentState as am,
  PreviewScorecardNavPaneAriaLabel as an,
  PublishedVersionsFilterOptions as ao,
  PublishedVersionListColumnNames as ap,
  PublishedVersionListCommandBarLabels as aq,
  getDraftFromPublishedVersion as ar,
  parseDate as as,
  PreviewDetailsListId as at,
  PreviewCommandBarId as au,
  PublishedVersionListLabels as av,
  TeachingBubbleProps as aw,
  teachingBubbleContent as ax,
  RecentPreviewAnalysisFilterOptions as ay,
  RecentPreviewAnalysisListColumnNames as az,
  loadProductionMetaDataEpicReducer as b,
  validateUnifiedExperiments as b0,
  validateLegacyExperiments as b1,
  validateForm as b2,
  getExperimentStepsOptions as b3,
  inCurrentWorkspaceFilter as b4,
  removeMetricSetFromList as b5,
  removeDraftFromList as b6,
  resetMergeMetricSetDraftStateActionName as b7,
  resetValidateMetricSetDraftStateActionName as b8,
  resetPublishMetricSetDraftStateActionName as b9,
  loadFeaturesForExperimentationGroupEpicReducerArg as ba,
  loadExperimentsForExperimentationGroupEpicReducerArg as bb,
  loadExperimentStepPlanSummariesEpicReducerArg as bc,
  validateExperimentStepsEpicReducerArg as bd,
  removeSegmentsFromList as be,
  addSegmentToList as bf,
  loadMetricSetDraftsEpicReducer as c,
  resetDeleteMetricSetDraftState as d,
  deleteMetricSetDraftEpicReducer as e,
  loadMetricSetDraftAggregationLevelsEpicReducer as f,
  loadMetricSetDraftRawColumnsEpicReducer as g,
  loadComputationFilePathsEpicReducer as h,
  loadColumnsEpicReducer as i,
  loadMetricsEpicReducer as j,
  loadComputationTemplatesEpicReducer as k,
  loadProductionHistoryEpicReducer as l,
  loadComputationTemplateInstancesEpicReducer as m,
  loadMetricsForCompuatationTemplateInstancesEpicReducer as n,
  loadColumnDetailsEpicReducer as o,
  createSegmentEpicReducer as p,
  resetCreateSegmentState as q,
  resetProductionDraftMetaDataState as r,
  checkUserMetricWriteAccessEpicReducer as s,
  loadExperimentationGroupsWithMetricWriteEpicReducer as t,
  loadAllExperimentationGroupsEpicReducer as u,
  vivaceEpics as v,
  createMetricSetEpicReducer as w,
  createMetricSetInstanceEpicReducer as x,
  cloneMetricSetEpicReducer as y,
  deleteMetricSetEpicReducer as z
};
//# sourceMappingURL=Vivace.epics-e2cdc8fc.js.map
